
// FRD: Shopify URL → prototype-like path alias mapper. Global so all IIFEs see it.
// Many features below gate on prototype handles (urun.html, sepet.html, ...).
// On Shopify, paths are /products/<handle>, /cart, /collections/<handle>, ...
// This helper produces a prototype-like alias so existing checks keep working.
window.frdPath = function frdPath(){
  var p = location.pathname;
  if (p === '/' || p === '' || p === '/index') return 'index.html';
  if (p.indexOf('/products/') === 0) return 'urun.html';
  if (p === '/cart' || p === '/cart/') return 'sepet.html';
  if (p.indexOf('/collections') === 0) return 'kategori.html';
  if (p === '/search' || p === '/search/') return 'arama.html';
  if (p === '/account/login' || p === '/account/register') return 'giris.html';
  if (p.indexOf('/account') === 0) return 'hesabim.html';
  if (p === '/checkout' || p.indexOf('/checkouts/') === 0 || p.indexOf('/thank') !== -1) return 'odeme.html';
  if (p.indexOf('/pages/') === 0){
    var h = p.split('/').filter(Boolean).pop();
    return (h || 'page') + '.html';
  }
  if (p.indexOf('/blogs/') === 0) return p.split('/').filter(Boolean).pop() + '.html';
  return location.pathname.split('/').filter(Boolean).pop() || 'index.html';
};

(function(){
  // alias for inner use
  var frdPath = window.frdPath;

  // --- Helpers ---
  function $(sel, root=document){ return root.querySelector(sel); }
  function $$(sel, root=document){ return [...root.querySelectorAll(sel)]; }
  function on(el, ev, fn){ if(el) el.addEventListener(ev, fn); }
  function ce(html){
    const t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  // --- Backdrop ---
  const backdrop = ce('<div class="backdrop"></div>');
  document.body.appendChild(backdrop);
  function showBackdrop(){ backdrop.classList.add('is-on'); }
  function hideBackdrop(){ backdrop.classList.remove('is-on'); }

  // --- Mobile menu (V74: dynamic from FRD_NAV_DATA / Shopify main-menu) ---
  const navInner = $('.nav__inner');
  if (navInner && !$('.hamburger')){
    const hb = ce('<button class="hamburger" aria-label="menu"><span></span></button>');
    navInner.insertBefore(hb, navInner.firstChild);

    const data = (window.FRD_NAV_DATA && window.FRD_NAV_DATA.menus) || {};
    const order = (window.FRD_NAV_DATA && window.FRD_NAV_DATA.order) || Object.keys(data);
    const quicktiles = (window.FRD_NAV_DATA && window.FRD_NAV_DATA.quicktiles) || [];
    const memberCta = (window.FRD_NAV_DATA && window.FRD_NAV_DATA.memberCta) || { text: 'Üye Ol · %10 Hoşgeldin', href: '/account/register' };

    let accordionHTML = '';
    if (order.length > 0) {
      accordionHTML = '<div class="mm-accordion">';
      order.forEach((key) => {
        const menu = data[key];
        if (!menu) return;
        const slug = (key || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').slice(0,12);
        const hotClass = menu.hot ? ' is-hot' : '';
        const label = menu.label || key;

        // V448 · Tek linklik başlık akordeon OLMAZ. Menüdeki altı başlığın beşi
        // (Yeni Sezon, Sonbaharın İlk Parçaları, Temel Parçalar, Sezon Sonu,
        // Outlet) içinde yalnız kendi adını taşıyan tek bir link barındırıyordu:
        // "Outlet"e gitmek hamburger → Outlet (açılır) → Outlet, yani üç dokunuş.
        // Böyle başlıklar doğrudan bağlantı olur. Tıklama handler'ı `data-open`
        // yoksa dokunmuyor, o yüzden <a> doğal gezinme yapar; `.mm-head` stili
        // zaten <a> için de tanımlı (veri gelmediğindeki fallback onu kullanıyor).
        const tumLinkler = (menu.cols || []).reduce((acc, c) => acc.concat(c.links || []), []);
        if (tumLinkler.length === 1) {
          accordionHTML += `<a class="mm-head${hotClass}" href="${tumLinkler[0][1]}">${label}</a>`;
          return;
        }

        accordionHTML += `<button class="mm-head${hotClass}" data-open="${slug}">${label} <span class="arr">+</span></button>`;
        accordionHTML += `<div class="mm-body" data-for="${slug}">`;
        (menu.cols || []).forEach((col) => {
          if (col.title && (menu.cols.length > 1 || col.showTitle)) {
            accordionHTML += `<div class="mm-sub">${col.title}</div>`;
          }
          (col.links || []).forEach(([t, href, k]) => {
            accordionHTML += `<a href="${href}">${t}${k ? '<span class="k">'+k+'</span>' : ''}</a>`;
          });
        });
        accordionHTML += `</div>`;
      });
      accordionHTML += '</div>';
    } else {
      // Fallback if no nav data
      accordionHTML = `<div class="mm-accordion"><a class="mm-head" href="/collections/all">Tüm Ürünler</a></div>`;
    }

    let quicktileHTML = '';
    if (quicktiles.length > 0) {
      quicktileHTML = '<div class="mm-quicktiles">';
      quicktiles.forEach((q) => {
        quicktileHTML += `<a href="${q.href}" aria-label="${q.label}">${q.icon || ''}<span>${q.label}</span></a>`;
      });
      quicktileHTML += '</div>';
    } else {
      // Default 4 tiles
      quicktileHTML = `
        <div class="mm-quicktiles">
          <a href="/cart"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 7h14l-1.5 12.5a1 1 0 0 1-1 .9H7.5a1 1 0 0 1-1-.9L5 7Z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg><span>Sepet</span></a>
          <a href="/pages/favoriler"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10Z"/></svg><span>Favoriler</span></a>
          <a href="/search"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg><span>Ara</span></a>
          <a href="/account"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></svg><span>Hesap</span></a>
        </div>`;
    }

    // V281: hızlı erişim döşemeleri gövdeden ALT bloğa taşındı. Gövdedeyken döşeme
    // sayısı 4'ün katı değilse (canlıda 5: +İade) 4 sütunlu grid'in boş hücresi
    // çizgi renginde kocaman bir bej blok olarak görünüyordu; ayrıca akordeon
    // kapalıyken döşemelerin altında ~250px ölü boşluk kalıyordu.
    const tagline = (document.querySelector('.nav__brand small')?.textContent || '').trim();

    const mm = ce(`
      <div class="mobileMenu" role="dialog" aria-modal="true" aria-label="Menü">
        <div class="mobileMenu__head">
          <span class="mobileMenu__brand">FARREN</span>
          <button class="mobileMenu__close" aria-label="Menüyü kapat">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M5 5l14 14M19 5 5 19"/></svg>
          </button>
        </div>
        <div class="mobileMenu__body">
          ${accordionHTML}
          <div class="mm-help" hidden></div>
          ${tagline ? `<div class="mobileMenu__sig">${tagline}</div>` : ''}
        </div>
        <div class="mobileMenu__foot">
          ${quicktileHTML}
          <a class="btn" href="${memberCta.href}">${memberCta.text}</a>
          <a class="mobileMenu__wa" href="https://wa.me/${String((window.FRD_NAV_DATA && window.FRD_NAV_DATA.whatsapp) || '905468919558').replace(/\D/g, '')}" target="_blank" rel="noopener">
                 <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.05L2 22l5.1-1.33A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.18-1.14l-.3-.18-3.03.79.81-2.95-.2-.31A8.2 8.2 0 1 1 12 20.2Zm4.5-6.14c-.25-.13-1.46-.72-1.68-.8-.23-.08-.39-.13-.55.12-.16.25-.64.8-.78.97-.14.16-.29.18-.53.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.23-1.46-1.37-1.7-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.44.13-.15.17-.25.25-.42.08-.16.04-.31-.02-.44-.06-.12-.55-1.33-.76-1.82-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.42.06-.64.31-.22.25-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.1.16 1.52.1.46-.07 1.46-.6 1.66-1.18.21-.58.21-1.07.15-1.18-.06-.1-.22-.16-.47-.28Z"/></svg>
                 <span>WhatsApp ile yazın · ${(window.FRD_NAV_DATA && window.FRD_NAV_DATA.whatsapp) || '0546 891 95 58'}</span>
               </a>
        </div>
      </div>
    `);
    document.body.appendChild(mm);
    const closeMM = () => { mm.classList.remove('is-open'); hideBackdrop(); };
    on(hb, 'click', () => { mm.classList.add('is-open'); showBackdrop(); });
    on(mm.querySelector('.mobileMenu__close'), 'click', closeMM);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mm.classList.contains('is-open')) closeMM();
    });

    // V281: akordeon kapalıyken panelin altında ~250px boş beyazlık kalıyordu.
    // Oraya uydurma içerik koymak yerine footer'daki "Yardım" sütunu birebir
    // yansıtılıyor: link listesi tek yerden (footer menüsü) yönetilir, burada
    // sabit URL yok. Sütun bulunamazsa bölüm hiç görünmez.
    const helpBox = mm.querySelector('.mm-help');
    function renderHelp(){
      if (!helpBox || helpBox.dataset.done) return;
      const heading = [...document.querySelectorAll('#footer-group h5')]
        .find((h) => /yard[ıi]m/i.test(h.textContent || ''));
      if (!heading) return;
      let list = heading.nextElementSibling;
      if (!list || !list.querySelector('a')) list = heading.parentElement;
      const tileHrefs = [...mm.querySelectorAll('.mm-quicktiles a')].map((a) => a.getAttribute('href'));
      const links = [...list.querySelectorAll('a')]
        .map((a) => ({ label: a.textContent.trim(), href: a.getAttribute('href') }))
        .filter((l) => l.label && l.href && !tileHrefs.includes(l.href))
        .slice(0, 6);
      if (!links.length) return;
      helpBox.innerHTML = `<div class="mm-help__t">${heading.textContent.trim()}</div>`
        + `<div class="mm-help__g">${links.map((l) => `<a href="${l.href}">${l.label}</a>`).join('')}</div>`;
      helpBox.hidden = false;
      helpBox.dataset.done = '1';
    }
    renderHelp();
    if (helpBox && !helpBox.dataset.done) window.addEventListener('load', renderHelp, { once: true });

    // Accordion behavior
    mm.addEventListener('click', (e) => {
      const head = e.target.closest('.mm-head');
      if (!head || !head.dataset.open) return;
      const key = head.dataset.open;
      const body = mm.querySelector('.mm-body[data-for="' + key + '"]');
      if (!body) return;
      const wasOpen = body.classList.contains('is-open');
      mm.querySelectorAll('.mm-body').forEach(b => b.classList.remove('is-open'));
      mm.querySelectorAll('.mm-head').forEach(h => h.classList.remove('is-open'));
      if (!wasOpen){ body.classList.add('is-open'); head.classList.add('is-open'); }
    });
  }

  // --- Cart drawer — FRD: real cart data via /cart.js ---
  const cartIcon = $('.nav__cart');
  if (cartIcon && !window.__cartDrawerInjected){
    window.__cartDrawerInjected = true;
    const drawer = ce('<aside class="cartDrawer" aria-label="Sepet"><div class="cartDrawer__head"><h3>Sepetim <span data-cart-item-count></span></h3><button class="cartDrawer__close" aria-label="kapat">×</button></div><div class="cartDrawer__body" data-cart-body><div style="padding:60px 22px;text-align:center;color:var(--ink-3);font-size:13px;">Yükleniyor…</div></div><div class="cartDrawer__foot" data-cart-foot style="display:none;"><div class="cartDrawer__total"><span>Toplam</span><b data-cart-total></b></div><div class="cartDrawer__taksit" data-cart-taksit style="order:2; text-align:right; margin:-8px 0 12px; font-size:12.5px; color:var(--ink-2);"></div><div class="perks" style="order:2; margin:0 0 13px; gap:6px 14px; flex-wrap:wrap; font-size:12.5px; color:var(--ink-2);"><span>✓ Ücretsiz kargo</span><span>✓ 14 gün içinde iade</span><span>✓ 3 taksit</span></div><a class="btn" href="/checkout">Ödeme sayfasına geç →</a><a class="btn btn--ghost" href="/cart" style="width:100%; justify-content:center; margin-top:8px;">Sepete Git</a></div></aside>');
    document.body.appendChild(drawer);

    function money(amount){
      return (amount/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' TL';
    }

    // 25 Ağu 2026 · Sepet sayfasındaki taksit tablosu ve güven modülü artık
    // çekmecede de var. Tablo tutarları sepet toplamından hesaplanır; güven
    // modülü layout'taki <template id="frd-trust-tpl"> klonlanarak gelir
    // (kart logoları Liquid'in payment_type_svg_tag çıktısı — JS içinde
    // telifli marka SVG'si taşımamak için).
    var KART_AILELERI = ['Axess','Bonus','Maximum','Paraf','World','Advantage','Bankkart','QNB','Sağlam Kart'];

    function paraSade(kurus){
      return (kurus/100).toLocaleString('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2});
    }

    function taksitTablosu(cart){
      var t2 = Math.floor(cart.total_price / 2);
      var t3 = Math.floor(cart.total_price / 3);
      var satirlar = KART_AILELERI.map(function(k){
        return '<tr><th scope="row">' + k + '</th>'
             + '<td>' + paraSade(cart.total_price) + '</td>'
             + '<td><b>' + paraSade(t2) + '</b></td>'
             + '<td><b>' + paraSade(t3) + '</b></td></tr>';
      }).join('');
      var el = document.createElement('details');
      el.className = 'frd-taksit';
      el.setAttribute('data-frd-taksit', '');
      el.style.order = '2';
      el.innerHTML =
        '<summary><span>Tüm taksit seçenekleri</span>'
        + '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>'
        + '</summary>'
        + '<div class="frd-taksit__body"><div class="frd-taksit__scroll">'
        + '<table class="frd-taksit__t"><thead><tr><th>Kart</th><th>Peşin</th><th>2 Taksit</th><th>3 Taksit</th></tr></thead>'
        + '<tbody>' + satirlar + '</tbody></table></div>'
        + '<p class="frd-taksit__not">Tüm seçeneklerde toplam aynı: <b>' + money(cart.total_price) + '</b> — vade farkı yok. '
        + 'Tutarlar yaklaşıktır; kartınıza özel taksit seçenekleri ödeme adımında kart numaranızı girdikten sonra görünür.</p>'
        + '</div>';
      return el;
    }

    function guvenModulu(){
      var tpl = document.getElementById('frd-trust-tpl');
      if (!tpl || !tpl.content) return null;           // şablon yoksa sessizce atla
      var kok = tpl.content.firstElementChild;
      if (!kok) return null;
      var kopya = kok.cloneNode(true);
      kopya.setAttribute('data-frd-trust', '');
      kopya.style.order = '3';
      return kopya;
    }

    function sepetModulleri(foot, cart){
      // renderCart her adet değişiminde yeniden çalışıyor; tablo açıkken
      // müşteri adedi değiştirirse kapanmasın diye açık durum taşınır.
      var eskiTaksit = foot.querySelector('[data-frd-taksit]');
      var acikti = !!(eskiTaksit && eskiTaksit.open);
      ['[data-frd-taksit]', '[data-frd-trust]'].forEach(function(sec){
        var eski = foot.querySelector(sec);
        if (eski && eski.parentNode) eski.parentNode.removeChild(eski);
      });
      if (!cart || !cart.item_count) return;
      var ghost = foot.querySelector('.btn--ghost');
      var tablo = taksitTablosu(cart);
      if (acikti) tablo.open = true;
      foot.insertBefore(tablo, ghost || null);
      var trust = guvenModulu();
      if (trust) foot.insertBefore(trust, ghost || null);
    }

    // --- FRD · sepet cekmecesi %10 hosgeldin (e-posta izni -> aninda kupon) ---
    var W10_CODE = 'HOSGELDIN10';
    function w10Styles(){
      if (document.getElementById('frdW10dCss')) return;
      var s = document.createElement('style');
      s.id = 'frdW10dCss';
      s.textContent = '.frdW10d{margin:0 0 10px;padding:10px;border:1px solid var(--line,#e7e2da);border-radius:9px;background:#faf8f5;}'
        + '.frdW10d__t{font-size:12.5px;color:#3d3a35;margin-bottom:6px;}'
        + '.frdW10d__t b{color:#6B1F2E;}'
        + '.frdW10d__f{display:flex;gap:6px;}'
        + '.frdW10d__f input[type=email]{flex:1;min-width:0;padding:8px 9px;border:1px solid #d9d3c9;border-radius:7px;font-size:13px;background:#fff;}'
        + '.frdW10d__f button{padding:8px 12px;border:0;border-radius:7px;background:#6B1F2E;color:#fff;font-size:12.5px;cursor:pointer;white-space:nowrap;}'
        + '.frdW10d__f button:disabled{opacity:.6;cursor:default;}'
        + '.frdW10d__c{display:flex;gap:6px;align-items:flex-start;margin-top:7px;font-size:11px;color:#6b665f;line-height:1.35;cursor:pointer;}'
        + '.frdW10d__m{margin:6px 0 0;font-size:11.5px;}'
        + '.frdW10d__m.ok{color:#2f7a3d;} .frdW10d__m.err{color:#b23b3b;}'
        + '.frdW10d__done{font-size:12.5px;color:#2f7a3d;}';
      document.head.appendChild(s);
    }
    function renderW10(cart, foot){
      var old = foot.querySelector('[data-frd-w10-drawer]');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      if (!cart || !cart.item_count) return;
      w10Styles();
      var applied = (cart.cart_level_discount_applications || []).length > 0;
      var box = document.createElement('div');
      box.className = 'frdW10d';
      box.setAttribute('data-frd-w10-drawer', '');
      if (applied){
        box.innerHTML = '<div class="frdW10d__done">✓ %10 hoşgeldin indirimi uygulandı</div>';
      } else {
        box.innerHTML = '<div class="frdW10d__t">İlk siparişinize <b>%10 indirim</b> — e-postanızı bırakın, hemen uygulansın.</div>'
          + '<div class="frdW10d__f"><input type="email" name="email" placeholder="E-posta adresiniz" aria-label="E-posta adresiniz"><button type="button">Uygula</button></div>'
          + '<label class="frdW10d__c"><input type="checkbox" name="consent"><span>Farren’den e-posta ile kampanya ve yenilik bildirimleri almak istiyorum.</span></label>'
          + '<p class="frdW10d__m" aria-live="polite" hidden></p>';
      }
      var cta = foot.querySelector('a.btn');
      if (cta) foot.insertBefore(box, cta); else foot.appendChild(box);
      if (applied) return;

      var inp = box.querySelector('input[type=email]');
      var chk = box.querySelector('input[name=consent]');
      var btn = box.querySelector('button');
      var msg = box.querySelector('.frdW10d__m');
      function show(t, ok){ msg.hidden = false; msg.textContent = t; msg.className = 'frdW10d__m ' + (ok ? 'ok' : 'err'); }
      on(btn, 'click', function(){
        var email = (inp.value || '').trim();
        if (!email || email.indexOf('@') < 1) return show('Geçerli bir e-posta girin.', false);
        if (!chk.checked) return show('Devam etmek için onay kutusunu işaretleyin.', false);
        btn.disabled = true; show('Uygulanıyor…', true);
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'newsletter,cart-welcome10');
        fd.append('contact[accepts_marketing]', 'true');
        fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
          .catch(function(){})
          .then(function(){ return fetch('/discount/' + encodeURIComponent(W10_CODE), { credentials: 'same-origin' }); })
          .then(function(){ return fetch('/cart.js'); })
          .then(function(r){ return r.json(); })
          .then(function(c){ renderCart(c); })
          .catch(function(){ show('İndirim uygulanamadı, tekrar deneyin.', false); btn.disabled = false; });
      });
    }

    function renderCart(cart){
      var body = drawer.querySelector('[data-cart-body]');
      var foot = drawer.querySelector('[data-cart-foot]');
      var cntEl = drawer.querySelector('[data-cart-item-count]');
      cntEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ' ürün)' : '';
      // Update header badge
      var badge = document.querySelector('[data-cart-count]');
      if (badge){ badge.textContent = cart.item_count; badge.style.display = cart.item_count>0 ? '' : 'none'; }

      if (cart.item_count === 0){
        body.innerHTML = '<div style="padding:60px 22px;text-align:center;"><div class="eyebrow" style="margin-bottom:14px;">Sepetiniz boş</div><h4 style="font-family:var(--display);font-size:22px;font-weight:500;margin:0 0 16px;color:var(--ink);">Bir parça seçmeye var mısınız?</h4><a class="btn" href="/collections/yeni-gelenler" style="display:inline-flex;">Koleksiyonu Keşfet</a></div>';
        foot.style.display = 'none';
        return;
      }

      var threshold = 75000;
      var remaining = Math.max(0, threshold - cart.total_price);
      var progress = Math.min(100, cart.total_price * 100 / threshold);
      var html = '<div class="cartDrawer__progress"><div>' + (remaining > 0 ? ('Ücretsiz kargoya <b>' + money(remaining) + '</b> kaldı.') : '<b style="color:var(--ok)">✓ Ücretsiz kargo</b>') + '</div><div class="bar"><div style="width:' + progress + '%"></div></div></div>';

      cart.items.forEach(function(it){
        var opts = (it.options_with_values || []).map(function(o){ return o.value; }).join(' · ');
        var img = it.image ? '<img src="' + it.image.replace('.jpg','_240x.jpg').replace('.png','_240x.png') + '" alt="" style="width:100%;height:100%;object-fit:cover;">' : '<div class="ph" data-label=""></div>';
        var priceHTML = (it.original_line_price > it.final_line_price) ? ('<del>' + money(it.original_line_price) + '</del>' + money(it.final_line_price)) : money(it.final_line_price);
        html += '<div class="cartDrawer__row" data-line-key="' + it.key + '"><a href="' + it.url + '" style="display:block;width:60px;height:78px;overflow:hidden;flex-shrink:0;">' + img + '</a><div><b><a href="' + it.url + '" style="color:inherit;">' + it.product_title + '</a></b><div class="meta">' + opts + '</div><div class="qty"><button type="button" data-q="dec">−</button><b>' + it.quantity + '</b><button type="button" data-q="inc">+</button></div></div><div class="px">' + priceHTML + '</div></div>';
      });

      body.innerHTML = html;
      foot.style.display = 'block';
      var eskiW10 = foot.querySelector('[data-frd-w10-drawer]');
      if (eskiW10 && eskiW10.parentNode) eskiW10.parentNode.removeChild(eskiW10);
      foot.querySelector('[data-cart-total]').textContent = money(cart.total_price);
      // Ön sipariş satırı varsa "14 gün içinde iade" maddesi değişim kuralını söyler.
      var preSay = cart.items.filter(function(it){ var h = it.properties && it.properties['Hazırlık']; return h && String(h).indexOf('Ön sipariş') === 0; }).length;
      foot.querySelectorAll('.perks span').forEach(function(s){
        if (!s.hasAttribute('data-frd-iade-perk') && /14 gün içinde iade/.test(s.textContent)) s.setAttribute('data-frd-iade-perk', '');
        if (!s.hasAttribute('data-frd-iade-perk')) return;
        s.textContent = !preSay ? '✓ 14 gün içinde iade'
          : (preSay === cart.items.length ? '✓ Ücretsiz beden değişimi' : '✓ 14 gün iade · ön siparişte beden değişimi');
      });
      sepetModulleri(foot, cart);
      var tkEl = foot.querySelector('[data-cart-taksit]');
      if (tkEl) tkEl.innerHTML = cart.total_price > 0
        ? ('veya <b style="color:var(--ink); font-weight:600;">3 taksit \u00d7 ' + money(Math.round(cart.total_price/3)) + '</b>')
        : '';
      // V511 · taksit adım şeridi — layout'taki frd-taksit-adim-tpl klonlanır
      // (markup tek kaynak: snippets/frd-taksit-adim.liquid).
      var eskiAdim = foot.querySelector('[data-frd-taksit-adim]');
      if (eskiAdim && eskiAdim.parentNode) eskiAdim.parentNode.removeChild(eskiAdim);
      var adimTpl = document.getElementById('frd-taksit-adim-tpl');
      if (tkEl && cart.total_price > 0 && adimTpl && adimTpl.content && adimTpl.content.firstElementChild) {
        var adim = adimTpl.content.firstElementChild.cloneNode(true);
        adim.setAttribute('data-frd-taksit-adim', '');
        tkEl.parentNode.insertBefore(adim, tkEl.nextSibling);
      }
      // 25 Ağu 2026 · Kullanıcı kararı: %10 hoşgeldin kutusu sepet çekmecesinden
      // de kaldırıldı (sepet sayfasından aynı gün kaldırılmıştı). Ödemeye geçmek
      // üzere olan müşteriye elinde olmayan bir indirim göstermek kupon avını
      // başlatıyordu. Kod hâlâ geçerli ve bülten bölümü, bekleyen-sepet sayfası
      // ile WhatsApp izin sayfasından veriliyor. Geri açmak için tek satır:
      // renderW10(cart, foot);


      // Wire qty buttons
      body.querySelectorAll('[data-q]').forEach(function(btn){
        on(btn, 'click', function(){
          var row = btn.closest('[data-line-key]');
          var key = row.getAttribute('data-line-key');
          var qty = parseInt(row.querySelector('.qty b').textContent, 10);
          qty = btn.dataset.q === 'inc' ? qty + 1 : Math.max(0, qty - 1);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({ id: key, quantity: qty })
          }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
        });
      });

      // V78: Cross-sell strip — Shopify recommendations API
      if (cart.items.length > 0) {
        var firstId = cart.items[0].product_id;
        fetch('/recommendations/products.json?product_id=' + firstId + '&limit=3&intent=complementary')
          .then(function(r){ return r.json(); })
          .then(function(data){
            if (!data.products || data.products.length === 0) return;
            var xs = document.createElement('div');
            xs.className = 'cartDrawer__crosssell';
            xs.style.cssText = 'padding: 16px 22px; border-top: 1px solid var(--line); background: var(--bg-alt);';
            xs.innerHTML = '<div class="eyebrow" style="margin-bottom: 10px;">Bunlarla da iyi gider</div>' +
              '<div class="cartDrawer__crosssell__row" style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;">' +
              data.products.slice(0, 3).map(function(p){
                var img = p.featured_image || (p.images && p.images[0]) || '';
                if (img && img.indexOf('http') !== 0) img = 'https:' + img;
                return '<a href="' + p.url + '" class="crosssell__card" style="display:block;text-decoration:none;color:inherit;background:var(--bg);padding:8px;">' +
                  (img ? '<img src="' + img.replace(/\.(jpg|png)/, '_200x.$1') + '" style="width:100%;aspect-ratio:3/4;object-fit:cover;display:block;">' : '<div class="ph" style="aspect-ratio:3/4;"></div>') +
                  '<div style="font-size:11px;font-weight:500;margin-top:6px;line-height:1.3;color:var(--ink);">' + p.title + '</div>' +
                  '<div style="font-size:11px;color:var(--ink-2);">' + money(p.price) + '</div>' +
                  '</a>';
              }).join('') +
              '</div>';
            // Insert before footer
            body.appendChild(xs);
          })
          .catch(function(){});
      }
    }

    function loadCart(){
      fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
    }

    on(cartIcon, 'click', function(e){
      e.preventDefault();
      drawer.classList.add('is-open');
      showBackdrop();
      loadCart();
    });
    on(drawer.querySelector('.cartDrawer__close'), 'click', function(){ drawer.classList.remove('is-open'); hideBackdrop(); });

    // Expose for external triggers (PDP add-to-cart)
    window.__cartDrawer = drawer;
    window.__cartDrawerReload = loadCart;
  }

  // --- Backdrop close-all ---
  on(backdrop, 'click', () => {
    $$('.mobileMenu, .cartDrawer').forEach(el => el.classList.remove('is-open'));
    $$('.modal').forEach(el => el.classList.remove('is-open'));
    hideBackdrop();
  });

  // --- Live chat ---
  if (!window.__chatInjected){
    window.__chatInjected = true;
    const btn = ce(`
      <button class="chatBtn" aria-label="Yardım al">
        <svg viewBox="0 0 24 24"><path d="M4 5h16v12H8l-4 4V5Z"/></svg>
        Yardım
        <span class="pulse"></span>
      </button>
    `);
    document.body.appendChild(btn);

    const panel = ce(`
      <div class="chatPanel" role="dialog" aria-label="Sohbet">
        <div class="chatPanel__head">
          <div class="av"></div>
          <div>
            <b>Farren Stüdyo</b><br>
            <span>Farren Destek · Çevrimiçi</span>
          </div>
          <button class="close" aria-label="kapat">×</button>
        </div>
        <div class="chatPanel__body">
          <div class="chatMsg is-them">
            Merhaba! Farren'ye hoş geldiniz. Size nasıl yardımcı olabilirim?
            <div class="chatMsg__time">Az önce</div>
          </div>
          <div class="chatMsg is-them">
            Bir parça mı arıyorsunuz, beden mi seçeceksiniz, yoksa kombin önerisi mi alacaksınız?
            <div class="chatMsg__time">Az önce</div>
          </div>
        </div>
        <div class="chatPanel__quick">
          <button>📦 Sipariş takibi</button>
          <button>📏 Beden önerisi</button>
          <button>💄 Kombin önerisi</button>
          <button>🔁 İade başlat</button>
        </div>
        <div class="chatPanel__input">
          <input type="text" placeholder="Yazın..." />
          <button aria-label="gönder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z"/></svg>
          </button>
        </div>
      </div>
    `);
    document.body.appendChild(panel);

    on(btn, 'click', () => panel.classList.toggle('is-open'));
    on(panel.querySelector('.close'), 'click', () => panel.classList.remove('is-open'));

    // V103-A · Tespit 1: Scroll-direction collapse — chat button mobilde
    // "TÜMÜNÜ GÖR" / "HEDİYEMİ AL" gibi sayfa CTA'larının üzerine biniyordu.
    // Scroll-down sırasında butonu gizle, scroll-up'ta ve durduğunda geri getir.
    // Panel açıkken hide tetiklenmez.
    //
    // NOT 1: class-based toggle (`chatBtn--hidden`) Shopify Horizon teması'nın
    //   sayfa-wide mutation observer'ı tarafından anında temizleniyordu.
    // NOT 2: `transform/opacity/pointer-events` inline `!important` ile bile
    //   Horizon CSS layer cascade'i tarafından override ediliyordu (canlı
    //   browser doğrulamasında ölçüldü). `display: none` ezilmiyor — bu
    //   yüzden hide state için onu kullanıyoruz. Anlık disappear olur,
    //   transition kaybı kabul edilebilir (CTA bloke olması daha kritik).
    (function chatScrollCollapse(){
      var lastY = window.scrollY;
      var HIDE_AFTER = 240;   // px — hero scrolldan sonra devreye girsin
      var DELTA = 6;          // küçük titreşimleri yoksay
      var idleTimer = null;
      var hidden = false;
      function hide(){
        if (hidden) return;
        hidden = true;
        btn.style.setProperty('display', 'none', 'important');
      }
      function show(){
        if (!hidden) return;
        hidden = false;
        btn.style.removeProperty('display');
      }
      function onScroll(){
        if (panel.classList.contains('is-open')) { show(); return; }
        var y = window.scrollY;
        var diff = y - lastY;
        if (y > HIDE_AFTER && diff > DELTA) {
          hide();
        } else if (diff < -DELTA || y <= HIDE_AFTER) {
          show();
        }
        lastY = y;
        clearTimeout(idleTimer);
        // 1.4s scroll durduktan sonra otomatik geri getir
        idleTimer = setTimeout(show, 1400);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    })();

    // Quick replies
    panel.querySelectorAll('.chatPanel__quick button').forEach(b => {
      on(b, 'click', () => {
        const body = panel.querySelector('.chatPanel__body');
        const me = ce(`<div class="chatMsg is-me">${b.textContent}<div class="chatMsg__time">Az önce</div></div>`);
        body.appendChild(me);
        body.scrollTop = body.scrollHeight;
        setTimeout(() => {
          const reply = ce(`<div class="chatMsg is-them">Hemen size yardımcı oluyorum. Bir bilginizi iletmemde olur mu? Sipariş numaranız veya hesap e-postanız varsa paylaşır mısınız?<div class="chatMsg__time">Az önce</div></div>`);
          body.appendChild(reply);
          body.scrollTop = body.scrollHeight;
        }, 700);
      });
    });
  }

  // --- Recently viewed (V83: gerçek Shopify ürünleri) ---
  // Eskiden hardcoded demo ürün listesi vardı. Artık /products/{handle}
  // sayfasında DOM'dan title/price/image yakalayıp localStorage'a yazıyor,
  // diğer sayfalarda gerçek kartları render ediyor.
  (function recentlyViewed(){
    var STORE_KEY = 'frd_recent_products';
    var MAX_ITEMS = 6;
    var path = location.pathname || '';
    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch(e){}

    // Capture on PDP — /products/{handle}
    // V104: Ürün yeniden adlandırılınca handle + URL değişiyor ve eski→yeni
    // 301 redirect kuruluyor. Eskiden dedup yalnız ham URL handle'ına bakıyordu,
    // bu yüzden aynı ürün rename öncesi (eski handle) ve sonrası (yeni handle)
    // iki ayrı kart olarak listeleniyordu. Artık SABIT kimliklerle dedup:
    //   1. ShopifyAnalytics product.id (rename'den etkilenmez)
    //   2. canonical handle (eski URL'de bile yeni handle'ı gösterir)
    var isPDP = path.indexOf('/products/') === 0;
    if (isPDP) {
      var canonical = (document.querySelector('link[rel="canonical"]') || {}).href || '';
      var canonicalHandle = canonical.indexOf('/products/') >= 0
        ? canonical.split('/products/')[1].split(/[?#/]/)[0]
        : '';
      var handle = canonicalHandle || path.replace(/^\/products\//,'').split(/[?#/]/)[0];
      var pid = '';
      try { pid = String((window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id) || ''); } catch(e){}
      var url = canonicalHandle ? ('/products/' + canonicalHandle) : path;
      var dupe = stored.find(function(r){
        return (pid && r.pid === pid) || r.handle === handle;
      });
      // V193 · KRİTİK BUG FIX: querySelector(virgüllü-liste) yazdığımız SIRAYA
      // göre değil, DOM SIRASINA göre ilk eşleşeni döndürür. Eski birleşik
      // selektördeki geniş fallback'ler (picture img, img[src*="products"],
      // img[src*="cdn.shopify"]) header'daki LOGO'yu (farren-logo.png galeriden
      // ÖNCE geliyor) yakalıyordu → her PDP'de ürün görseli yerine logo kaydediliyor,
      // "Son görüntülediğiniz" kartlarının hepsi aynı kırpık logo ("R") oluyordu.
      // Çözüm: SADECE galeri kapsamı; logo/placeholder'ı ele; görünür (seçili
      // renk) slot'u tercih et, yoksa ilk geçerli ürün görseli.
      var imgEl = null;
      var galImgs = document.querySelectorAll('.pdp__gallery img, .product__media img, .product-gallery img');
      for (var _gi = 0; _gi < galImgs.length; _gi++) {
        var _g = galImgs[_gi];
        var _s = _g.getAttribute('src') || _g.currentSrc || '';
        if (!_s || /logo|placeholder|sprite|icon/i.test(_s)) continue;
        if (_g.offsetParent !== null) { imgEl = _g; break; } // görünür slot = seçili renk
        if (!imgEl) imgEl = _g;                               // fallback: ilk geçerli
      }
      var capturedImg = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';

      if (handle && !dupe) {
        // V193b · Aynı DOM-sırası tuzağı burada da vardı: PDP'de fiyat selektörü
        // 9 elemana uyuyor (cart drawer, öneriler, quick-add fiyatları dahil) ve
        // doğru fiyat yalnızca .pdp__price'ın DOM'da önce gelmesi SAYESİNDE
        // yakalanıyordu — sıralama değişirse yanlış fiyat kaydedilir. Çözüm: ürün
        // bilgi bloğuna (.pdp__info) scope + kaynak-sırası öncelikli AYRI sorgular.
        var infoRoot = document.querySelector('.pdp__info') || document;
        var titleEl = infoRoot.querySelector('.pdp__name')
                   || infoRoot.querySelector('.pdp__title')
                   || infoRoot.querySelector('h1.product__title')
                   || infoRoot.querySelector('h1');
        var priceEl = infoRoot.querySelector('.pdp__price')
                   || infoRoot.querySelector('.price__current')
                   || infoRoot.querySelector('.price-item--regular')
                   || infoRoot.querySelector('[data-product-price]');
        var oldEl   = infoRoot.querySelector('.pdp__priceOld')
                   || infoRoot.querySelector('.price__compare')
                   || infoRoot.querySelector('.price-item--sale del');
        var item = {
          handle: handle,
          pid: pid,
          url: url,
          title: titleEl ? titleEl.textContent.trim() : handle,
          price: priceEl ? priceEl.textContent.trim().replace(/\s+/g,' ') : '',
          old:   oldEl   ? oldEl.textContent.trim() : '',
          image: capturedImg,
          ts: Date.now()
        };
        if (item.image) {
          stored.unshift(item);
          stored = stored.slice(0, MAX_ITEMS);
          try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){}
        }
      } else if (handle && dupe && capturedImg) {
        // V193: zaten kayıtlı ürün tekrar gezildiğinde, eski buglu kayıttaki
        // eksik/logo görseli gerçek ürün görseliyle İYİLEŞTİR (dedupe capture'ı
        // atladığı için aksi halde placeholder'da takılı kalırdı).
        var wasBad = !dupe.image || /logo|placeholder|sprite|icon/i.test(dupe.image);
        if (wasBad) {
          dupe.image = capturedImg;
          try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){}
        }
      }
    }

    // V104: Eski localStorage kayıtlarında (pid yokken, rename öncesi/sonrası
    // farklı handle ile) zaten birikmiş duplikeleri temizle. Aynı ürün = aynı
    // pid VEYA aynı görsel. Farklı renk varyantları ayrı görsel taşıdığı için
    // yanlışlıkla birleşmez. İlk (en yeni) kayıt tutulur.
    (function dedupeStored(){
      var seen = {};
      var cleaned = stored.filter(function(r){
        var key = r.pid || r.image || r.handle;
        if (!key || seen[key]) return false;
        seen[key] = 1;
        return true;
      });
      if (cleaned.length !== stored.length) {
        stored = cleaned;
        try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){}
      }
    })();

    // V193: eski buglu capture LOGO'yu image olarak kaydetmişti. Bu bayat
    // kayıtlardaki logo görselini boşalt ki kart kırpık logo yerine temiz
    // placeholder göstersin; kullanıcı ürünü tekrar gezince doğru görsel yakalanır.
    (function purgeLogoImages(){
      var changed = false;
      stored.forEach(function(r){
        if (r.image && /logo|placeholder|sprite|icon/i.test(r.image)) { r.image = ''; changed = true; }
      });
      if (changed) { try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){} }
    })();

    // Render on home & collections (NOT on PDP itself)
    var shouldRender = stored.length >= 2 && !isPDP;
    if (!shouldRender) return;
    if (document.querySelector('.recentlyViewed')) return;

    var strip = ce(
      '<section class="recentlyViewed">'
      + '<div class="wrap">'
      + '<h3>Son görüntülediğiniz</h3>'
      + '<div class="recentlyViewed__row"></div>'
      + '</div>'
      + '</section>'
    );
    var row = strip.querySelector('.recentlyViewed__row');
    // V83 fix: eski localStorage kayıtlarında fiyat alanı PDP'den etiketlerle
    // ("Normal fiyat 2.149,90TL ...") yakalanmış olabiliyordu — sadece para
    // token'ını çıkar ki kartlarda metin birbirine girmesin.
    var cleanPrice = function(s){
      if (!s) return '';
      var m = String(s).match(/[\d.,]+\s*(?:TL|₺)/i);
      var out = m ? m[0] : String(s);
      // V193: mağaza para formatıyla tutarlı → sayı ile TL/₺ arasında TEK boşluk
      // ("2.499,90 TL"). Eskiden tüm boşluklar siliniyordu → "2.499,90TL" bitişik.
      return out.replace(/\s+/g, ' ').replace(/([\d.,])\s*(TL|₺)/i, '$1 $2').trim();
    };
    var attr = function(s){ return String(s == null ? '' : s).replace(/"/g, '&quot;'); };
    stored.forEach(function(p){
      var price = cleanPrice(p.price);
      var old   = cleanPrice(p.old);
      var priceHtml = old ? '<del>'+old+'</del> <span>'+price+'</span>' : price;
      var media = p.image
        ? '<img src="' + attr(p.image) + '" alt="" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">'
        : '<div class="ph" data-label="' + attr((p.title || '').toLowerCase()) + '"></div>';
      // V83 fix: <article onclick> yerine gerçek <a href> — storefront CSP
      // inline onclick'i bloklayıp kartları tıklanamaz bırakıyordu.
      var card = ce(
        '<a class="card" data-handle="' + attr(p.handle || '') + '" href="' + attr(p.url || '#') + '">'
        + '<div class="card__media" style="position:relative;overflow:hidden;">' + media + '</div>'
        + '<div class="card__body">'
        + '<div class="card__name">' + (p.title || '') + '</div>'
        + '<div class="card__price">' + priceHtml + '</div>'
        + '</div>'
        + '</a>'
      );
      row.appendChild(card);
    });

    var footer = $('.foot');
    if (footer) footer.parentNode.insertBefore(strip, footer);

    // 24 Eki 2026 · Kayıtlı fiyat, ürüne bakıldığı andaki fiyattı: indirim ya da
    // zam sonrası kart bayat fiyat gösteriyor, taslağa alınan ürüne 404 link
    // veriyordu. Kartlar çizildikten sonra güncel fiyat /products/{handle}.js'ten
    // okunur; ürün artık yoksa kart ve kayıt silinir.
    var tl = function(kurus){ return (kurus / 100).toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' TL'; };
    stored.slice().forEach(function(p){
      if (!p.handle) return;
      var card = row.querySelector('[data-handle="' + attr(p.handle) + '"]');
      fetch('/products/' + encodeURIComponent(p.handle) + '.js').then(function(res){
        if (res.status === 404) return 'yok';
        return res.ok ? res.json() : null;
      }).then(function(j){
        if (j === 'yok') {
          if (card) card.remove();
          stored = stored.filter(function(s){ return s.handle !== p.handle; });
          try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){}
          if (!row.children.length) strip.remove();
          return;
        }
        if (!j || !card) return;
        var yeni = tl(j.price);
        var eskiFiyat = j.compare_at_price && j.compare_at_price > j.price ? tl(j.compare_at_price) : '';
        var el = card.querySelector('.card__price');
        if (el) el.innerHTML = eskiFiyat ? '<del>' + eskiFiyat + '</del> <span>' + yeni + '</span>' : yeni;
        p.price = yeni; p.old = eskiFiyat;
        try { localStorage.setItem(STORE_KEY, JSON.stringify(stored)); } catch(e){}
      }).catch(function(){});
    });
  })();

  // V83 fix: outer-scope `path` lost when recently-viewed IIFE replaced the
  // old `const path = frdPath();` declaration. Restore so the exit-intent
  // modal + sticky ATC blocks below don't ReferenceError (which was killing
  // the mega menu init that lives further down in the same file).
  const path = frdPath();

  // --- Bülten pop-up'ı (V312) — altı yüzey + GERÇEK kayıt -------------------
  //
  // Neden yeniden yazıldı:
  //  1) Eski blokta "Kuponu Al" düğmesinin hiçbir dinleyicisi yoktu; girilen
  //     e-posta hiçbir yere gitmiyordu. Artık /contact'a POST ediliyor.
  //  2) Eski blok `if (localStorage.getItem(dayKey)) return;` ile DIŞ IIFE'den
  //     çıkıyordu → pop-up bir kez görüldükten sonra o gün boyunca yapışkan
  //     sepete-ekle çubuğu, "stoğa gelince haber ver" ve sepet bildirimi hiç
  //     kurulmuyordu. Blok artık kendi IIFE'si içinde; return güvenli.
  //  3) Tetikleyici yalnız mouseleave + masaüstü 60 sn yedeğiydi → mobilde hiç
  //     görünmüyordu. Mobil artık alt şerit alıyor.
  //
  // Yüzey → tasarım eşlemesi (tasarım teklifindeki A–F):
  //   mobil (her sayfa) .................. F · alt şerit
  //   daha önce kapatmış ................. B · köşe kartı
  //   ürün sayfası ....................... D · yalın tipografi
  //   koleksiyon sayfası ................. C · tam kadraj
  //   sepet .............................. E · iki adım
  //   diğer (ana sayfa, arama, sayfalar).. A · sessiz bölme
  //
  // Renk/tipografi canlı temanın kendi token'larından alınır (--accent vb.);
  // marka kılavuzundaki Fraunces/#6B1F2E DEĞİL — pop-up eklenti gibi durmasın.
  (function frnNewsletterPopup(){
    var PATH = frdPath();
    if (['giris.html','hesabim.html','odeme.html'].indexOf(PATH) !== -1) return;
    if (location.pathname.indexOf('/checkout') === 0) return;
    if (document.querySelector('.frn-np')) return;

    // V397-popup-huni · Reklamdan gelen ziyaretçi ürün sayfasına tıklama parası ödenerek
    // geldi (3,73 TL/tık). Ona önce ÜRÜNÜ göster: bülten formu fotoğrafın ve
    // sticky sepet çubuğunun üstüne binmesin. Ana sayfa/koleksiyon/sepet
    // yüzeyleri bundan etkilenmez.
    try {
      var _qs = new URLSearchParams(location.search);
      var _src = (_qs.get('utm_source') || '').toLowerCase();
      if (_qs.get('fbclid') || _qs.get('ttclid') || _qs.get('gclid') ||
          /facebook|instagram|meta|^ig$|^fb$/.test(_src)) {
        sessionStorage.setItem('frn_ad_session', '1');
      }
    } catch(e){}
    // V612 · Masaüstünde kural aynı. Mobilde bu kural ziyaretçilerin çoğunu pop-up'tan
    // tümüyle çıkarıyordu (ayda ~33 kayıt): ürünü kapatmayan alt şerit, ziyaretçi
    // ürüne bakıp aşağı indikten sonra gösterilir (bkz. AD_PDP_BEKLEME).
    var adPdp = false;
    try {
      if (sessionStorage.getItem('frn_ad_session') === '1' && PATH === 'urun.html') {
        if (!(window.matchMedia && window.matchMedia('(max-width: 720px)').matches)) return;
        adPdp = true;
      }
    } catch(e){}

    var LS = {
      get: function(k){ try { return localStorage.getItem(k); } catch(e){ return null; } },
      set: function(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
    };
    var DAY_KEY = 'frn_np_day_' + new Date().toISOString().slice(0,10);

    // V478 · GÖNDERİM SONRASI DÖNÜŞ.
    // Kayıt artık gerçek form gönderimiyle yapılıyor (aşağıdaki nota bak);
    // Shopify /contact'a POST edip sayfayı `?customer_posted=true` ile geri
    // getiriyor. Kupon kartını burada gösteriyoruz — normal gösterim kuralları
    // (gün bayrağı, done) bu dönüşü engellemesin diye kontrollerden ÖNCE.
    if (LS.get('frn_np_pending') && /[?&]customer_posted=true/.test(location.search)){
      LS.set('frn_np_done','1');
      try { localStorage.removeItem('frn_np_pending'); } catch(e){}
      try {
        var okCss = document.createElement('style');
        okCss.textContent = '.frn-np-ok{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);'
          + 'z-index:2147483000;max-width:min(420px,calc(100vw - 32px));background:#0c0c0c;color:#fff;'
          + 'padding:14px 18px;font:400 13px/1.5 var(--sans,system-ui);letter-spacing:.01em;'
          + 'box-shadow:0 10px 34px rgba(12,12,12,.28)}'
          + '.frn-np-ok b{font-weight:600;letter-spacing:.06em}';
        document.head.appendChild(okCss);
        var okEl = document.createElement('div');
        okEl.className = 'frn-np-ok';
        okEl.setAttribute('role','status');
        okEl.innerHTML = 'Hoş geldiniz. Kupon kodunuz: <b>HOSGELDIN10</b> — ödeme adımında %10 iner.';
        document.body.appendChild(okEl);
        setTimeout(function(){ okEl.remove(); }, 9000);
      } catch(e){}
      return;
    }

    if (LS.get('frn_np_done')) return;      // zaten abone oldu → bir daha sorma
    if (LS.get(DAY_KEY)) return;            // bugün gösterildi

    var CODE     = 'HOSGELDIN10';
    var LOGO     = 'https://cdn.shopify.com/s/files/1/0932/1853/7751/files/farren-logo.png?v=1781904932';
    var IMG_EDIT = 'https://cdn.shopify.com/s/files/1/0932/1853/7751/files/frn-popup-saks.jpg?v=1793366168';
    var IMG_SPLIT= IMG_EDIT;
    var IMG_FAB  = 'https://cdn.shopify.com/s/files/1/0932/1853/7751/files/frn-popup-fabric.jpg?v=1786122738';
    var LEGAL    = 'Devam ederek <a href="/policies/privacy-policy">Gizlilik Politikası</a>\'nı ve '
                 + '<a href="/pages/kvkk">KVKK Aydınlatma Metni</a>\'ni kabul etmiş olursunuz.';

    var isMobile  = window.matchMedia && window.matchMedia('(max-width: 720px)').matches;
    var dismissed = LS.get('frn_np_dismissed');
    if (adPdp && dismissed) return;         // reklam ziyaretçisi şeridi kapattıysa bir daha sorma
    var variant   = isMobile          ? 'f'
                  : dismissed         ? 'b'
                  : PATH==='urun.html'      ? 'd'
                  : PATH==='kategori.html'  ? 'c'
                  : PATH==='sepet.html'     ? 'e'
                  : 'a';

    // --- stil (bir kez) ---
    if (!document.getElementById('frn-np-css')){
      var css = document.createElement('style');
      css.id = 'frn-np-css';
      css.textContent = [
'.frn-np{--np-paper:#FAFAF7;--np-ink:var(--ink,#0c0c0c);--np-accent:var(--accent,#7a1f2b);',
'  --np-accent-dk:var(--accent-dk,#4c1119);--np-earth:#8B7355;--np-line:#d9d3c9;',
'  position:fixed;inset:0;z-index:9500;display:grid;place-items:center;padding:30px;',
'  font-family:Manrope,-apple-system,system-ui,sans-serif;color:var(--np-ink);}',
// KRITIK: yazar `display` kurali, UA stil sayfasindaki [hidden]{display:none} kuralini yener.
// Bu satir olmadan pop-up `hidden` olmasina ragmen gorunur ve tetikleyici mantigi atlanir.
'.frn-np[hidden]{display:none!important}',
// tema global bir box-sizing vermiyorsa width:100% + padding tasar; kendi kapsamimizda garanti altina al
'.frn-np,.frn-np *,.frn-np *::before,.frn-np *::after{box-sizing:border-box}',
'.frn-np__veil{position:absolute;inset:0;background:rgba(26,20,18,.42);animation:frnFade .45s ease both}',
'.frn-np--bare{background:none;pointer-events:none;place-items:end;padding:26px}',
'.frn-np--bar{background:none;pointer-events:none;place-items:end stretch;padding:0}',
'.frn-np--bare .frn-np__veil,.frn-np--bar .frn-np__veil{display:none}',
'.frn-np__card{position:relative;background:var(--np-paper);pointer-events:auto;',
'  box-shadow:0 30px 70px -25px rgba(30,20,16,.55);max-width:100%;max-height:100%;overflow:auto;',
'  animation:frnUp .55s cubic-bezier(.16,.84,.32,1) both}',
'@keyframes frnFade{from{opacity:0}to{opacity:1}}',
'@keyframes frnUp{from{opacity:0;transform:translateY(20px) scale(.99)}to{opacity:1;transform:none}}',
'@media (prefers-reduced-motion:reduce){.frn-np *,.frn-np{animation:none!important}}',
'.frn-np__x{position:absolute;top:16px;right:16px;width:30px;height:30px;display:grid;place-items:center;',
'  background:none;border:0;cursor:pointer;color:inherit;opacity:.55;padding:0;z-index:3;line-height:1}',
'.frn-np__x:hover{opacity:1}',
'.frn-np__x svg{width:13px;height:13px;stroke:currentColor;stroke-width:1.3;fill:none}',
'.frn-np__logo{display:block;width:112px;height:auto}',
'.frn-np__rule{width:34px;height:1px;background:var(--np-earth);margin:2px 0 4px}',
'.frn-np__h{font-family:"Cormorant Garamond",Georgia,serif;font-size:33px;line-height:1.14;',
'  letter-spacing:-.008em;margin:0;font-weight:400}',
'.frn-np__h em{font-style:italic;color:var(--np-accent)}',
'.frn-np__p{font-size:14px;line-height:1.62;color:#4a4440;margin:0}',
'.frn-np__eyebrow{font-size:10.5px;letter-spacing:.2em;color:var(--np-earth)}',
'.frn-np__legal{font-size:10.5px;line-height:1.5;color:#928a83;margin:0}',
'.frn-np__legal a{color:inherit}',
'.frn-np__skip{background:none;border:0;padding:0;font:inherit;font-size:11.5px;letter-spacing:.06em;',
'  color:#928a83;text-decoration:underline;text-underline-offset:3px;cursor:pointer;align-self:flex-start}',
'.frn-np__skip:hover{color:var(--np-ink)}',
'.frn-np__form{display:flex;align-items:flex-end;gap:12px;margin:0}',
'.frn-np__form input{flex:1;min-width:0;appearance:none;background:transparent;border:0;',
'  border-bottom:1px solid var(--np-line);font:inherit;font-size:14px;color:var(--np-ink);padding:11px 0;outline:0;border-radius:0}',
'.frn-np__form input::placeholder{color:#a49c94}',
'.frn-np__form input:focus{border-bottom-color:var(--np-accent)}',
'.frn-np__btn{appearance:none;border:0;cursor:pointer;background:var(--np-accent);color:#fff;font:inherit;',
'  font-size:11.5px;letter-spacing:.14em;padding:14px 24px;white-space:nowrap;transition:background .25s;border-radius:0}',
'.frn-np__btn:hover{background:var(--np-accent-dk)}',
'.frn-np__btn[disabled]{opacity:.6;cursor:default}',
'.frn-np__ok{font-size:13.5px;line-height:1.55;color:#2f6b45;margin:0}',
'.frn-np__ok b{font-family:"Cormorant Garamond",Georgia,serif;font-size:16px;font-weight:400}',
'.frn-np__err{font-size:12.5px;color:#a4302f;margin:0}',
// A
'.frn-np__card--a{width:880px;display:grid;grid-template-columns:340px 1fr}',
'.frn-np__card--a .frn-np__img{background:url('+IMG_SPLIT+') center 12%/cover}',
'.frn-np__body{padding:52px 54px;display:flex;flex-direction:column;gap:18px}',
// B
'.frn-np__card--b{width:392px;padding:28px;border-top:2px solid var(--np-accent);display:flex;flex-direction:column;gap:14px}',
'.frn-np__card--b .frn-np__top{display:flex;gap:16px;align-items:flex-start}',
'.frn-np__chip{width:62px;height:62px;flex:none;background:url('+IMG_FAB+') center/cover}',
'.frn-np__card--b .frn-np__h{font-size:21px;line-height:1.22}',
'.frn-np__card--b .frn-np__btn{padding:13px 17px;font-size:15px;letter-spacing:0}',
'.frn-np__card--b .frn-np__x{top:10px;right:10px}',
// C
'.frn-np__card--c{width:500px;height:660px;background:#1a1a1a;color:#fff;display:flex;flex-direction:column;',
'  justify-content:flex-end;overflow:hidden}',
'.frn-np__card--c .frn-np__bg{position:absolute;inset:0;background:url('+IMG_EDIT+') center 16%/cover}',
'.frn-np__card--c .frn-np__scrim{position:absolute;inset:0;background:',
'  linear-gradient(to top,rgba(20,14,12,.97) 0%,rgba(20,14,12,.93) 34%,rgba(20,14,12,.62) 60%,rgba(20,14,12,.06) 100%),',
'  linear-gradient(to bottom,rgba(20,14,12,.55) 0%,rgba(20,14,12,0) 24%)}',
'.frn-np__card--c .frn-np__logo{position:absolute;top:26px;left:42px;z-index:2;width:104px;filter:brightness(0) invert(1)}',
'.frn-np__card--c .frn-np__body{position:relative;padding:42px 42px 38px;gap:16px}',
'.frn-np__card--c .frn-np__h{color:#fff;font-size:34px}',
'.frn-np__card--c .frn-np__h em{color:#e8c9d1}',
'.frn-np__card--c .frn-np__p{color:rgba(255,255,255,.82)}',
'.frn-np__card--c .frn-np__eyebrow{color:#d9c9b4}',
'.frn-np__card--c .frn-np__legal{color:rgba(255,255,255,.52)}',
'.frn-np__card--c .frn-np__legal a{color:rgba(255,255,255,.8)}',
'.frn-np__card--c .frn-np__skip{color:rgba(255,255,255,.6)}',
'.frn-np__card--c .frn-np__skip:hover{color:#fff}',
'.frn-np__card--c .frn-np__form input{color:#fff;border-bottom-color:rgba(255,255,255,.45)}',
'.frn-np__card--c .frn-np__form input::placeholder{color:rgba(255,255,255,.55)}',
'.frn-np__card--c .frn-np__btn{background:#FAFAF7;color:#1a1a1a}',
'.frn-np__card--c .frn-np__btn:hover{background:#fff}',
'.frn-np__card--c .frn-np__x{color:#fff;opacity:.8;top:18px;right:18px}',
'.frn-np__card--c .frn-np__ok{color:#c6e8d2}',
// D
'.frn-np__card--d{width:620px;padding:56px 58px;display:flex;flex-direction:column;gap:18px;border:1px solid #E6E0D5}',
'.frn-np__card--d .frn-np__rule{background:var(--np-accent);width:40px}',
'.frn-np__card--d .frn-np__h{font-size:38px}',
// E
'.frn-np__card--e{width:430px;overflow:hidden}',
'.frn-np__card--e .frn-np__img{height:200px;background:url('+IMG_FAB+') center 42%/cover}',
'.frn-np__card--e .frn-np__body{padding:34px 36px 32px;gap:15px}',
'.frn-np__card--e .frn-np__h{font-size:27px}',
'.frn-np__card--e .frn-np__btn{width:100%;text-align:center}',
'.frn-np__card--e .frn-np__x{top:14px;right:14px;color:#fff;background:rgba(20,14,12,.28);border-radius:50%;opacity:.9}',
'.frn-np__card--e .frn-np__skip{align-self:center}',
'.frn-np__back{align-self:flex-start;background:none;border:0;padding:0;font:inherit;font-size:11.5px;color:#928a83;cursor:pointer}',
'.frn-np__back:hover{color:var(--np-ink)}',
// F
'.frn-np__card--f{width:100%;border-top:1px solid #E2DCD1;padding:20px 40px;display:flex;align-items:center;gap:30px;',
'  box-shadow:0 -14px 34px -22px rgba(30,20,16,.4);animation:frnBar .5s cubic-bezier(.16,.84,.32,1) both}',
'@keyframes frnBar{from{transform:translateY(100%)}to{transform:none}}',
'.frn-np__card--f .frn-np__logo{flex:none;width:88px;align-self:center}',
'.frn-np__card--f .frn-np__txt{display:flex;align-items:baseline;gap:14px;flex-wrap:wrap;flex:1;min-width:0}',
'.frn-np__card--f .frn-np__h{font-size:21px;white-space:nowrap}',
'.frn-np__card--f .frn-np__sub{font-size:13px;color:#6b635d}',
'.frn-np__card--f .frn-np__form{width:400px;flex:none}',
'.frn-np__card--f .frn-np__x{position:static;flex:none}',
// mobil
'@media (max-width:720px){',
' .frn-np{padding:14px}',
' .frn-np__card--f{position:relative;flex-direction:column;align-items:stretch;gap:10px;padding:18px 40px 20px 150px;min-height:216px}',
' .frn-np__thumb{position:absolute;left:0;top:0;bottom:0;width:132px;background:url('+IMG_EDIT+') 50% 14%/cover}',
' .frn-np__card--f .frn-np__form{width:100%}',
' .frn-np__card--f .frn-np__logo{display:none}',
' .frn-np__card--f .frn-np__txt{flex-direction:column;align-items:flex-start;gap:4px}',
' .frn-np__card--f .frn-np__h{font-size:21px;white-space:normal}',
' .frn-np__card--f .frn-np__x{position:absolute;top:8px;right:8px}',
' .frn-np__card--a{width:100%;max-width:340px;grid-template-columns:1fr;grid-template-rows:200px auto}',
' .frn-np__card--b,.frn-np__card--d,.frn-np__card--e{width:100%;max-width:340px}',
' .frn-np__card--c{width:100%;max-width:340px;height:auto;min-height:520px}',
' .frn-np__body{padding:28px 26px;gap:14px}',
' .frn-np__h{font-size:26px}',
' .frn-np__card--d{padding:32px 28px}',
' .frn-np__card--d .frn-np__h{font-size:27px}',
' .frn-np__form{flex-direction:column;align-items:stretch;gap:14px}',
' .frn-np__btn{width:100%}',
'}'
      ].join('\n');
      document.head.appendChild(css);
    }

    var XSVG = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13"/></svg>';
    var LOGO_IMG = '<img class="frn-np__logo" src="' + LOGO + '" alt="Farren" width="112" height="23" loading="lazy">';
    // V478 · GERÇEK SHOPIFY FORMU — ham fetch ÇALIŞMIYOR.
    // Mağazada spam koruması açık. Shopify'ın hCaptcha kancası formu
    //   form[action*='/contact'] input[name='form_type'][value='customer']
    // seçicisiyle buluyor; `action` ve gizli `form_type` yoksa token
    // üretilmiyor ve POST **400 "Missing CAPTCHA token"** ile reddediliyor.
    // Eski sürüm bunu fetch ile gönderiyordu; fetch HTTP 400'de REJECT ETMEZ,
    // bu yüzden `.then` çalışıp kullanıcıya kupon kodu gösteriliyor ama kayıt
    // hiç oluşmuyordu — 7 Ağu'dan 29 Ağu'ya kadar popup-* etiketli SIFIR kayıt.
    // Artık form normal gönderiliyor: sayfa /contact'a POST edip
    // ?customer_posted=true ile dönüyor, kupon bildirimi yukarıda gösteriliyor.
    var FORM = function(cta){
      return '<form class="frn-np__form" action="/contact" method="post" accept-charset="UTF-8">'
           +   '<input type="hidden" name="form_type" value="customer">'
           +   '<input type="hidden" name="utf8" value="\u2713">'
           +   '<input type="hidden" name="contact[tags]" value="newsletter,popup-' + (adPdp ? 'f-reklam' : variant) + '">'
           +   '<input type="hidden" name="contact[accepts_marketing]" value="true">'
           +   '<input type="email" name="contact[email]" required autocomplete="email" placeholder="E-posta adresiniz" aria-label="E-posta adresiniz">'
           +   '<button class="frn-np__btn" type="submit">' + cta + '</button>'
           + '</form>';
    };
    var SKIP = '<button class="frn-np__skip" type="button" data-np-skip>Şimdi değil</button>';
    var X    = '<button class="frn-np__x" type="button" aria-label="Kapat" data-np-close>' + XSVG + '</button>';

    var TPL = {
      a: '<div class="frn-np__veil" data-np-close></div>'
       + '<div class="frn-np__card frn-np__card--a" role="dialog" aria-modal="true" aria-label="Bültene katılın">'
       +   '<div class="frn-np__img"></div>'
       +   '<div class="frn-np__body">' + X + LOGO_IMG + '<div class="frn-np__rule"></div>'
       +     '<h2 class="frn-np__h">Yeni gelenleri <em>ilk siz</em> görün.</h2>'
       +     '<p class="frn-np__p">Bültene katılın; ilk siparişinizde %10 indirim kuponu sizin olsun. Yeni parçalar herkesten 48 saat önce kutunuza düşer.</p>'
       +     FORM('KUPON KODUMU GÖNDER')
       +     '<p class="frn-np__legal">' + LEGAL + '</p>' + SKIP
       +   '</div></div>',

      b: '<div class="frn-np__card frn-np__card--b" role="dialog" aria-label="Bültene katılın">' + X + LOGO_IMG
       +   '<div class="frn-np__top"><div class="frn-np__chip"></div>'
       +     '<div><h2 class="frn-np__h">İlk siparişinizde <em>%10 indirim</em></h2>'
       +     '<p class="frn-np__p" style="margin-top:6px">E-postanızı bırakın, kodu hemen gönderelim.</p></div></div>'
       +   FORM('&rarr;') + '<p class="frn-np__legal">' + LEGAL + '</p></div>',

      c: '<div class="frn-np__veil" data-np-close></div>'
       + '<div class="frn-np__card frn-np__card--c" role="dialog" aria-modal="true" aria-label="Bültene katılın">'
       +   '<div class="frn-np__bg"></div><div class="frn-np__scrim"></div>' + LOGO_IMG + X
       +   '<div class="frn-np__body">'
       +     '<div class="frn-np__eyebrow">YENİ GELENLER</div>'
       +     '<h2 class="frn-np__h">Yeni parçalar,<br><em>herkesten önce.</em></h2>'
       +     '<p class="frn-np__p">Bültene katılın; ilk siparişinizde %10 indirim kuponu ve koleksiyona 48 saat ön erişim.</p>'
       +     FORM('KATIL') + '<p class="frn-np__legal">' + LEGAL + '</p>' + SKIP
       +   '</div></div>',

      d: '<div class="frn-np__veil" data-np-close></div>'
       + '<div class="frn-np__card frn-np__card--d" role="dialog" aria-modal="true" aria-label="Bültene katılın">' + X + LOGO_IMG
       +   '<div class="frn-np__rule"></div>'
       +   '<h2 class="frn-np__h">Kumaşı <em>önce siz</em> görün.</h2>'
       +   '<p class="frn-np__p">Yeni parçalar herkesten 48 saat önce. Katılın, ilk siparişinizde %10 indirim kuponu sizin olsun.</p>'
       +   FORM('KUPON KODUMU GÖNDER') + '<p class="frn-np__legal">' + LEGAL + '</p>' + SKIP + '</div>',

      e: '<div class="frn-np__veil" data-np-close></div>'
       + '<div class="frn-np__card frn-np__card--e" role="dialog" aria-modal="true" aria-label="Bültene katılın">'
       +   '<div class="frn-np__img">' + X + '</div>'
       +   '<div class="frn-np__body">'
       +     '<div data-np-step="1">' + LOGO_IMG
       +       '<h2 class="frn-np__h" style="margin-top:12px">İlk siparişinizde <em>%10 indirim</em></h2>'
       +       '<p class="frn-np__p" style="margin-top:12px">Bir de yeni parçalara 48 saat ön erişim. İster misiniz?</p>'
       +       '<div style="display:flex;flex-direction:column;gap:11px;margin-top:16px">'
       +         '<button class="frn-np__btn" type="button" data-np-next>EVET, KUPONU İSTİYORUM</button>' + SKIP
       +       '</div></div>'
       +     '<div data-np-step="2" hidden>'
       +       '<button class="frn-np__back" type="button" data-np-back>&larr; Geri</button>'
       +       '<h2 class="frn-np__h" style="margin-top:12px;font-size:24px">Nereye gönderelim?</h2>'
       +       '<div style="margin-top:16px">' + FORM('GÖNDER') + '</div>'
       +       '<p class="frn-np__legal" style="margin-top:14px">' + LEGAL + '</p>'
       +     '</div></div></div>',

      f: '<div class="frn-np__card frn-np__card--f" role="dialog" aria-label="Bültene katılın"><div class="frn-np__thumb"></div>' + LOGO_IMG
       +   '<div class="frn-np__txt"><h2 class="frn-np__h">İlk siparişinizde <em>%10 indirim</em></h2>'
       +     '<span class="frn-np__sub">Bültene katılın, indirim kuponunuzdan hemen faydalanın.</span></div>'
       +   FORM('GÖNDER') + X + '</div>'
    };

    // Sepet teklifi yalnız DOLU sepette anlamlı; boş sepette A'ya düşer.
    if (variant === 'e'){
      fetch('/cart.js', { credentials:'same-origin' })
        .then(function(r){ return r.json(); })
        .then(function(c){ init(c && c.item_count > 0 ? 'e' : 'a'); })
        .catch(function(){ init('a'); });
    } else {
      init(variant);
    }

    function init(variant){
    var wrapCls = 'frn-np' + (variant==='b' ? ' frn-np--bare' : variant==='f' ? ' frn-np--bar' : '');
    var root = ce('<div class="' + wrapCls + '" hidden>' + TPL[variant] + '</div>');
    document.body.appendChild(root);

    // --- kapatma ---
    var lastFocus = null;
    function close(userAction){
      root.remove();
      if (userAction) LS.set('frn_np_dismissed','1');
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch(e){} }
    }
    function onKey(e){ if (e.key === 'Escape') close(true); }
    root.addEventListener('click', function(e){
      if (e.target.closest('[data-np-close]') || e.target.closest('[data-np-skip]')) { close(true); return; }
      if (e.target.closest('[data-np-next]')){
        root.querySelector('[data-np-step="1"]').hidden = true;
        var s2 = root.querySelector('[data-np-step="2"]'); s2.hidden = false;
        var i = s2.querySelector('input'); if (i) i.focus();
        return;
      }
      if (e.target.closest('[data-np-back]')){
        root.querySelector('[data-np-step="2"]').hidden = true;
        root.querySelector('[data-np-step="1"]').hidden = false;
      }
    });

    // --- gönderim ---
    // ARAYA GİRİLMİYOR: `preventDefault` yalnız geçersiz e-postada çağrılır.
    // Geçerli girişte formu Shopify'ın hCaptcha kancası devralır (submit'i
    // kendisi durdurur, token'ı ekler, sonra gönderir). Burada tekrar
    // durdurursak token hiç üretilmez ve POST 400 döner — eski hata buydu.
    root.addEventListener('submit', function(e){
      var form = e.target.closest('.frn-np__form');
      if (!form) return;
      var input = form.querySelector('input[type="email"]');
      var old   = form.parentNode.querySelector('.frn-np__err');
      if (old) old.remove();
      if (!input.value.trim() || !input.checkValidity()){
        e.preventDefault();
        form.insertAdjacentHTML('afterend', '<p class="frn-np__err">Geçerli bir e-posta adresi girin.</p>');
        input.focus();
        return;
      }
      // Dönüşte kupon kartını gösterebilmek için hangi yüzeyden gittiğini yaz.
      LS.set('frn_np_pending', variant);
      form.querySelector('button').disabled = true;
      try { if (window.dataLayer) window.dataLayer.push({event:'newsletter_signup', popup_variant:variant}); } catch(err){}
    });

    // --- gösterim ---
    // Çerez bandı (.frn-ck) ekrandayken pop-up açılmaz: aynı anda iki şey sorulmaz,
    // mobilde de ikisi alt alta çakışıyordu. Bant kapanınca sıraya girer.
    // Bant DOM'a geç girdiği için yalnız DOM'a bakmak yetmiyor: rıza kaydı
    // (farren_cookie_v1) yoksa bant er ya da geç çıkacak demektir → bekle.
    function cookieBannerUp(){
      if (!LS.get('farren_cookie_v1')) return true;
      var b = document.querySelector('.frn-ck');
      if (!b) return false;
      var cs = getComputedStyle(b);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
      return b.getBoundingClientRect().height > 0;
    }

    var shown = false, waitTimer = null, cooling = false, drawerTimer = null;
    // Sepet çekmecesi (.cartDrawer.is-open) açıkken pop-up görünmez: mobilde alt bant
    // toplamın ve "Güvenli Ödeme" butonunun üstüne biniyordu. Çekmece kapanınca
    // kaldığı yerden devam eder.
    function cartDrawerOpen(){
      return !!document.querySelector('.cartDrawer.is-open');
    }
    // V397-popup-huni · Bant kapanır kapanmaz pop-up açılıyordu → arka arkaya iki modal;
    // ziyaretçi ürünü görmeden ikinci kez "kapat"a basmak zorunda kalıyordu.
    // Nefes payını bandın KAPANDIĞI ana bağlıyoruz: ilgi sinyali banttan önce de
    // sonra da oluşsa 30 sn korunur.
    var NP_COOLDOWN = 30000;
    var bannerGoneAt = 0;
    (function watchBanner(){
      var wasUp = cookieBannerUp();
      if (!wasUp) return;                 // bant hiç çıkmadı (rıza zaten var)
      var iv = setInterval(function(){
        var up = cookieBannerUp();
        if (wasUp && !up){ bannerGoneAt = Date.now(); clearInterval(iv); }
        wasUp = up;
      }, 250);
      setTimeout(function(){ clearInterval(iv); }, 120000);
    })();
    // V612 · Alt şerit ürün sayfasındaki sticky "Sepete Ekle"nin üstüne binmesin.
    function barKaldir(){
      var s = document.querySelector('.sticky-atc.is-on'), h = 0;
      if (s){
        var r = s.getBoundingClientRect();
        if (r.height > 0) h = Math.max(0, window.innerHeight - r.top);
      }
      root.style.paddingBottom = h ? h + 'px' : '';
    }
    function show(){
      if (shown || cooling) return;
      if (bannerGoneAt){
        var kalan = NP_COOLDOWN - (Date.now() - bannerGoneAt);
        if (kalan > 0){
          cooling = true;
          setTimeout(function(){ cooling = false; show(); }, kalan);
          return;
        }
      }
      if (cookieBannerUp()){
        if (!waitTimer){
          waitTimer = setInterval(function(){
            if (!cookieBannerUp()){ clearInterval(waitTimer); waitTimer = null; show(); }
          }, 500);
        }
        return;
      }
      if (cartDrawerOpen()){
        if (!drawerTimer){
          drawerTimer = setInterval(function(){
            if (!cartDrawerOpen()){ clearInterval(drawerTimer); drawerTimer = null; show(); }
          }, 500);
        }
        return;
      }
      shown = true;
      lastFocus = document.activeElement;
      if (variant === 'f') barKaldir();
      root.hidden = false;
      LS.set(DAY_KEY, '1');
      // Pop-up açıkken çekmece açılırsa (sepete ekleme) geri çekil, kapanınca dön.
      var drawerWatch = setInterval(function(){
        if (!root.isConnected){ clearInterval(drawerWatch); return; }
        root.hidden = cartDrawerOpen();
        if (variant === 'f') barKaldir();
      }, 300);
      if (variant !== 'b' && variant !== 'f') document.addEventListener('keydown', onKey);
    }

    // etkileşim eşiği: 200px kaydırma VEYA bir tıklama VEYA 8 sn
    var engaged = false;
    function markEngaged(){ engaged = true; }
    document.addEventListener('scroll', function(){ if (window.scrollY >= 200) markEngaged(); }, { passive:true });
    // V397-popup-huni · Çerez bandındaki "Kabul Et/Reddet" dokunuşu ilgi sayılıyordu;
    // bu yüzden bant kapanır kapanmaz pop-up tetikleniyordu.
    document.addEventListener('click', function(ev){
      try {
        if (ev.target && ev.target.closest &&
            ev.target.closest('.frn-ck, .frn-cc, #farren-cookie')) return;
      } catch(e){}
      markEngaged();
    });
    setTimeout(markEngaged, 8000);

    if (adPdp){
      // V612 · Reklamdan gelen tıklama parası ödenerek geldi: ilk ekranda hiçbir şey
      // çıkmaz; hem süre dolmuş hem ziyaretçi aşağı inmiş olmalı.
      var AD_PDP_BEKLEME = 40000, acilis = Date.now();
      var tAd = setInterval(function(){
        if (Date.now() - acilis >= AD_PDP_BEKLEME && window.scrollY >= 300){ clearInterval(tAd); show(); }
      }, 1000);
    } else if (variant === 'b' || variant === 'f'){
      // sayfayı kesmeyen yüzeyler: etkileşimden sonra nazikçe gir
      var t = setInterval(function(){ if (engaged) { clearInterval(t); show(); } }, 1000);
    } else {
      // bloke eden yüzeyler: çıkış niyeti + masaüstü 60 sn yedeği (eski davranış)
      document.addEventListener('mouseleave', function(e){
        if (e.clientY > 0) return;      // yalnızca tepeden çıkış
        if (!engaged) return;
        show();
      });
      setTimeout(function(){ if (engaged) show(); }, 60000);
    }
    } // init
  })();

  // --- Sticky add-to-cart bar (PDP only) — FRD: real product data from page DOM ---
  if (path === 'urun.html'){
    // Pull real data from FRD PDP DOM
    var pdpName = (document.querySelector('.pdp__name') || {}).textContent || '';
    var pdpPrice = (document.getElementById('frd-price') || {}).textContent || '';
    var pdpCmp = (document.getElementById('frd-cprice') || {}).textContent || '';
    var pdpColor = (document.getElementById('frd-color-label') || {}).textContent || '';
    var pdpSizeBtn = document.querySelector('[data-frd-size-picker] button.is-on');
    // V444: beden butonunda artık ikincil dil karşılığı da var (S + <small>36</small>);
    // textContent ikisini birleştirip "S36" veriyordu. Seçilen beden dataset'ten okunur.
    var pdpSize = pdpSizeBtn ? (pdpSizeBtn.dataset.value || '').trim() : '';
    var pdpMedia = '';
    var pdpImg = document.querySelector('.pdp__gallery img');
    if (pdpImg) pdpMedia = '<img src="' + pdpImg.src + '" alt="" style="width:100%;height:100%;object-fit:cover;">';
    else pdpMedia = '<div class="ph sticky-atc__media" data-label=""></div>';

    var info = [pdpColor, pdpSize].filter(Boolean).join(' · ');
    // V94: sticky ATC price separator — eski + yeni fiyat birleşik görünüyordu
    var priceHTML = pdpCmp ? '<del style="color:var(--ink-3);font-size:12px;margin-right:6px;">' + pdpCmp + '</del><span style="color:var(--accent-dk);font-weight:600;">' + pdpPrice + '</span>' : pdpPrice;

    const bar = ce('<div class="sticky-atc"><div class="sticky-atc__media" style="overflow:hidden;">' + pdpMedia + '</div><div class="sticky-atc__info"><b>' + pdpName + '</b>' + (info ? '<span>' + info + '</span>' : '') + '</div><div class="sticky-atc__price">' + priceHTML + '</div><button type="button" class="btn sticky-atc__btn" id="frd-sticky-atc">Sepete Ekle</button></div>');
    document.body.appendChild(bar);

    /* V257-taksit-gorunurluk · sticky çubukta taksit satırı (ilk ekranda görünen tek yüzey).
       Tutar gösterilen fiyattan türetilir: "2.199,90 TL" -> 2199.90 -> /3 */
    try {
      var _tkNum = parseFloat(String(pdpPrice || '').replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.'));
      var _tk = Math.round(_tkNum / 3);
      var _tkEl = bar.querySelector('.sticky-atc__price');
      if (_tkEl && isFinite(_tk) && _tk > 0) {
        _tkEl.insertAdjacentHTML('beforeend',
          '<small class="sticky-atc__taksit" id="frd-sticky-taksit">3 taksit × ' + _tk + '₺</small>');
      }
    } catch (e) { /* taksit satırı kritik değil — sticky çubuğu asla bozma */ }

    // Wire sticky ATC to product form
    on(bar.querySelector('#frd-sticky-atc'), 'click', function(){
      var form = document.getElementById('frd-product-form');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    // Sync sticky bar info with variant changes
    function syncStickyBar(){
      var c = (document.getElementById('frd-color-label') || {}).textContent || '';
      var sb = document.querySelector('[data-frd-size-picker] button.is-on');
      var s = sb ? (sb.dataset.value || '').trim() : '';  // V444: bkz. yukarısı — textContent "M38" verirdi
      var p = (document.getElementById('frd-price') || {}).textContent || '';
      var cp = (document.getElementById('frd-cprice') || {}).textContent || '';
      var infoEl = bar.querySelector('.sticky-atc__info span');
      var priceEl = bar.querySelector('.sticky-atc__price');
      var combined = [c, s].filter(Boolean).join(' · ');
      if (!infoEl && combined) {
        var spn = document.createElement('span');
        spn.textContent = combined;
        bar.querySelector('.sticky-atc__info').appendChild(spn);
      } else if (infoEl) {
        infoEl.textContent = combined;
      }
      if (priceEl) priceEl.innerHTML = cp ? '<del>' + cp + '</del>' + p : p;
    }
    document.querySelectorAll('[data-frd-color-picker] button, [data-frd-size-picker] button').forEach(function(b){
      on(b, 'click', function(){ setTimeout(syncStickyBar, 60); });
    });

    let pdpInfo = $('.pdp__info');
    if (pdpInfo){
      const obs = new IntersectionObserver(entries => {
        entries.forEach(en => {
          if (en.isIntersecting){
            bar.classList.remove('is-on');
          } else {
            bar.classList.add('is-on'); /* frn-sticky-first-screen V-CRO: ana CTA ekranda değilse (ilk ekran dahil) göster */
          }
        });
      }, { threshold: 0 });
      const ctas = $('.pdp__ctas');
      if (ctas) obs.observe(ctas);
    }
  }

  // --- Notify me on out-of-stock (PDP) ---
  // V103-I-fix2 · T-NOTIFY-BTN: Auto-popup davranışı kaldırıldı.
  // Önce: oos size click → otomatik modal (yanıltıcı, kullanıcı yanlışlıkla
  // tıklayınca modal açılıyordu).
  // Şimdi: PDP'de ATC altında ayrı "Stoğa gelince haber ver" butonu var
  // (#frd-notify-btn, sadece variant.available:false ise görünür).
  // showStockAlert global olarak window'a expose edildi ki PDP scope'tan
  // çağrılabilsin.
  if (path === 'urun.html'){
    const notifyBtn = document.querySelector('#frd-notify-btn');
    if (notifyBtn) {
      on(notifyBtn, 'click', function(){
        var sizeBtn = document.querySelector('[data-frd-size-picker] .is-on');
        var colorBtn = document.querySelector('[data-frd-color-picker] .is-on');
        var label = '';
        if (sizeBtn) label = sizeBtn.dataset.value;
        if (colorBtn && sizeBtn) label = colorBtn.dataset.value + ' / ' + sizeBtn.dataset.value;
        showStockAlert(label || 'bu');
      });
    }
  }
  window.showStockAlert = showStockAlert;
  // V106 · T-NOTIFY-MEASURE: PDP DOM'undan talep verisini topla
  // (#frd-product-data ürün JSON'u + #frd-variant-id + renk/beden picker).
  function collectStockNotify(){
    var product = {}, variantId = '';
    try {
      var el = document.getElementById('frd-product-data');
      if (el) product = JSON.parse(el.textContent) || {};
    } catch(e){}
    var vidEl = document.getElementById('frd-variant-id');
    if (vidEl) variantId = vidEl.value || '';
    var sizeBtn = document.querySelector('[data-frd-size-picker] .is-on');
    var colorBtn = document.querySelector('[data-frd-color-picker] .is-on');
    return {
      product: product.title || '',
      handle: product.handle || '',
      productId: product.id ? String(product.id) : '',
      variantId: variantId ? String(variantId) : '',
      renk: colorBtn ? colorBtn.dataset.value : '',
      beden: sizeBtn ? sizeBtn.dataset.value : '',
      source: 'pdp-widget'
    };
  }

  function showStockAlert(size){
    const m = ce(`
      <div class="modal stockAlert is-open">
        <div class="modal__box">
          <button class="modal__close">×</button>
          <div class="modal__body">
            <div class="eyebrow">Stoğa girince haber verelim</div>
            <h2 style="font-size:28px;">${size} beden hazır olunca <em class="italic">ilk siz bilin</em>.</h2>
            <p>E-posta adresinizi bırakın, hazır olur olmaz bildirelim. Sözünü tutamayacağımız bir tarih vermiyoruz — genelde 2-4 hafta arası.</p>
            <input type="email" id="sa-input" autocomplete="email" placeholder="E-posta adresiniz" />
            <button class="btn" id="sa-submit" style="width:100%; justify-content:center;">Beni haberdar et</button>
            <small style="display:block; margin-top:10px;">Yalnızca bu beden için — pazarlama bültenine değil.</small>
            <div id="sa-success" style="display:none; text-align:center; padding:18px 0 4px; color:var(--ok,#3a7a4f); font-size:14px;">✓ Kaydedildi · Hazır olunca size haber vereceğiz.</div>
          </div>
        </div>
      </div>
    `);
    document.body.appendChild(m);
    showBackdrop();
    const close = () => { m.remove(); hideBackdrop(); };
    on(m.querySelector('.modal__close'), 'click', close);
    on(m.querySelector('#sa-submit'), 'click', () => {
      const input = m.querySelector('#sa-input');
      if (!input.value.trim()) { input.focus(); input.style.borderColor = 'var(--hot, #a23d2a)'; return; }
      input.style.display = 'none';
      m.querySelector('#sa-submit').style.display = 'none';
      m.querySelector('small').style.display = 'none';
      m.querySelector('#sa-success').style.display = 'block';
      setTimeout(close, 1800);
      var payload = collectStockNotify();
      payload.contact = input.value.trim();
      // V157: kimlik köprüsü — e-postayı sakla + _fbp/_fbc/fbclid'i ekle.
      try { if (window.FarrenIdentity) window.FarrenIdentity.set(payload.contact); } catch(e){}
      var fb = (window.FarrenIdentity && window.FarrenIdentity.fbParams) ? window.FarrenIdentity.fbParams() : {};
      payload.fbp = fb.fbp || undefined;
      payload.fbc = fb.fbc || undefined;
      payload.fbclid = fb.fbclid || undefined;
      try {
        fetch('https://farren-agent.vercel.app/api/stock-notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          keepalive: true
        }).catch(function(){});
      } catch(e){}
    });
  }

  // --- Add to cart flash ---
  window.cartFlash = function(text){
    const f = ce(`
      <div class="cartFlash">
        <svg viewBox="0 0 24 24"><path d="m5 12 5 5L20 7"/></svg>
        <span>${text}</span>
      </div>
    `);
    document.body.appendChild(f);
    setTimeout(() => f.classList.add('is-on'), 10);
    setTimeout(() => { f.classList.remove('is-on'); setTimeout(() => f.remove(), 400); }, 2200);
  };

})();


// === EXT: Push notification permission prompt — V103-I-fix4 DEVRE DIŞI ===
// "İzin ver" yalnızca localStorage'a flag yazıyordu; gerçek
// Notification.requestPermission() / Service Worker / push backend YOK.
// Var olmayan bir servis için izin istemek yanıltıcı → kapatıldı.
// (V216 not: bu kapatma 7 Haz ff0fcbb'de yapılmıştı ama main'e merge edilmedi,
// 12 Tem V193 deploy'u canlıda geri açtı — yeniden uygulanıyor.)
// Gerçek web-push altyapısı kurulduğunda erken-return kaldırılır.
(function(){
  return;
  const path = frdPath();
  if (!['/cart','/checkout','urun.html'].includes(path)) return;
  if (localStorage.getItem('ml_push_asked')) return;

  setTimeout(() => {
    const m = document.createElement('div');
    m.className = 'modal is-open';
    m.innerHTML = `
      <div class="modal__box" style="max-width: 460px;">
        <button class="modal__close">×</button>
        <div class="modal__body" style="padding: 36px 40px;">
          <div style="font-family: var(--display); font-size: 56px; color: var(--accent-dk); line-height: 1; margin-bottom: 18px;">🔔</div>
          <h2 style="font-size: 26px; margin-bottom: 12px;">Stok bildirimleri açık mı olsun?</h2>
          <p style="font-size: 14px; color: var(--ink-2); margin: 0 0 22px; line-height: 1.6;">Tükenen bedeniniz dolduğunda, sepetinizdeki bir parçanın fiyatı düştüğünde veya kargonuz çıktığında size haber verelim. Yalnız sipariş ile ilgili — pazarlama yok.</p>
          <div style="display:flex; gap: 10px;">
            <button class="btn btn--ghost" id="pushNo" style="flex:1; justify-content: center;">Daha sonra</button>
            <button class="btn" id="pushYes" style="flex:1; justify-content: center;">İzin ver</button>
          </div>
          <p style="font-size: 11px; color: var(--ink-3); margin: 14px 0 0; line-height: 1.5; text-align: center;">İstediğiniz an Hesabım > Bildirim Tercihleri'nden iptal edebilirsiniz.</p>
        </div>
      </div>
    `;
    document.body.appendChild(m);
    document.querySelector('.backdrop')?.classList.add('is-on');
    const close = () => {
      m.remove();
      document.querySelector('.backdrop')?.classList.remove('is-on');
      localStorage.setItem('ml_push_asked','1');
    };
    m.querySelector('.modal__close').onclick = close;
    m.querySelector('#pushNo').onclick = close;
    m.querySelector('#pushYes').onclick = () => { localStorage.setItem('ml_push_granted','1'); close(); };
  }, 60000);
})();

// === EXT: Language/currency switcher in utility bar ===
(function(){
  const tr = document.querySelector('.utility__right a[href*="hesabim"]');
  if (tr && tr.textContent.includes('TR · TRY')) {
    tr.setAttribute('href', 'dil.html');
  }
})();

// === EXT: Heatmap overlay (debug/demo only — Tweaks tetiklerse aktif olur) ===
(function(){
  if (!window.location.search.includes('heatmap=1')) return;
  const css = document.createElement('style');
  css.textContent = `
    .heatmap-dot{ position:absolute; pointer-events:none; width: 60px; height: 60px;
      background: radial-gradient(circle, rgba(162,61,42,.4) 0, rgba(162,61,42,0) 70%);
      transform: translate(-50%, -50%); border-radius: 50%; z-index: 9999; }
  `;
  document.head.appendChild(css);
  // Simulated clicks on common attention zones
  const targets = ['.hero__ctas .btn', '.card__media', '.btn', '.nav__cart', '.chatBtn', '.summary__cta'];
  targets.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width/2 + window.scrollX;
      const cy = r.top + r.height/2 + window.scrollY;
      // multiple overlapping dots = heat
      const intensity = sel === '.hero__ctas .btn' || sel === '.summary__cta' ? 8 : 3;
      for (let i = 0; i < intensity; i++) {
        const d = document.createElement('div');
        d.className = 'heatmap-dot';
        d.style.left = (cx + (Math.random()-.5)*40) + 'px';
        d.style.top = (cy + (Math.random()-.5)*40) + 'px';
        document.body.appendChild(d);
      }
    });
  });
  // Badge
  const b = document.createElement('div');
  b.style.cssText = 'position:fixed;top:96px;left:24px;z-index:99999;background:var(--ink);color:var(--bg);padding:8px 14px;font-size:11px;letter-spacing:.14em;text-transform:uppercase;';
  b.textContent = 'Heatmap: aktif (kapatmak için ?heatmap=1 kaldırın)';
  document.body.appendChild(b);
})();

// === EXT: Sahte Apple Pay / Google Pay butonları KALDIRILDI (CRO) ===
// Bu butonlar gerçek cüzdan ödemesi başlatmıyordu; sadece location.href='/checkout'
// ile standart iyzico kart-giriş checkout'una atıyordu. "Apple Pay" deyip tek-tık
// cüzdan bekleyen müşteriyi kart formuna düşürmek ödeme anında güveni zedeliyor.
// Basic plan + iyzico'da (TR'de Shopify Payments yok) gerçek express cüzdan
// mümkün değil; yanıltıcı buton bırakmaktansa kaldırıldı.

// === EXT: Notify-when-back-in-stock (alias for the existing OOS modal — already in widgets) ===
// Beden ipucu + Bedenimi Bul. V521: manken bilgisi yalnız ürüne özel custom.manken doluysa (window.FRN_MANKEN_BILGI)
(function(){
  const path = frdPath();
  if (path !== 'urun.html') return;
  const sizesEl = document.querySelector('.pdp__sizes');
  if (!sizesEl) return;
  if (document.querySelector('.modelHint')) return;
  const hint = document.createElement('div');
  hint.className = 'modelHint';
  hint.style.cssText = 'margin-top: 12px; padding: 12px 16px; background: var(--bg-alt); border: 1px solid var(--line); font-size: 12.5px; color: var(--ink-2); display:flex; gap: 12px; align-items: center;';
  hint.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--accent-dk)" stroke-width="1.5" style="flex:0 0 auto;"><circle cx="12" cy="6" r="3"/><path d="M9 9v12M15 9v12"/></svg>
    <span>${window.FRN_MANKEN_BILGI ? 'Modelimiz <b style="color: var(--ink); font-weight: 500;">' + String(window.FRN_MANKEN_BILGI).replace(/[<>&"]/g, '') + '</b> giyiyor. Sizinki ne olur sorusu için' : 'Bedeninizden emin değil misiniz?'} <a href="/pages/beden-bul" style="color: var(--ink); border-bottom: 1px solid var(--line);">Bedenimi Bul</a> anketimize bakın.</span>
  `;
  // V203 · NetWork'te .options kutusunda yalnız renk + beden + sepete ekle var.
  // Manken ipucu kutunun DIŞINA, hemen altına konur (bilgi kaybolmasın diye
  // silinmedi; ayrıca "Detay" tablosunda "Manken Ölçüsü" satırı da var).
  const optionsBox = sizesEl.closest('.pdp__options');
  if (optionsBox && optionsBox.parentNode) {
    hint.style.marginTop = '0';
    hint.style.marginBottom = '16px';
    optionsBox.parentNode.insertBefore(hint, optionsBox.nextSibling);
  } else {
    sizesEl.parentNode.insertBefore(hint, sizesEl.nextSibling);
  }
})();


// === EXT: Auto-upgrade product placeholders to richer "photo" look ===
(function(){
  // Convert default placeholders in product cards and hero into photo-style gradients
  document.querySelectorAll('.card__media .ph:not(.ph--ink):not(.ph--accent), .pdp__gallery .ph:not(.ph--ink):not(.ph--accent), .heroGen__img .ph:not(.ph--ink):not(.ph--accent)').forEach((el, i) => {
    // Skip if already styled differently
    if (Math.random() > 0.4) el.classList.add('ph--photo');
  });
})();

// === EXT: 360° preview on PDP — V103-I-fix4 DEVRE DIŞI ===
// 8 boş çerçeve gösteriyordu (gerçek 360° foto yok). Sürükle-döndür çalışıyor
// ama içerik boş → yanıltıcı. Gerçek çok-açılı çekim eklenince return kaldırılır.
// (V216 not: bu kapatma 7 Haz ff0fcbb'de yapılmıştı ama main'e merge edilmedi,
// 12 Tem V193 deploy'u canlıda geri açtı — yeniden uygulanıyor.)
(function(){
  return;
  const path = frdPath();
  if (path !== 'urun.html') return;
  // Insert 360 widget into the gallery if not present
  const gallery = document.querySelector('.pdp__gallery');
  if (!gallery || document.querySelector('.spin360')) return;

  // Add a 360 viewer as a new gallery cell (span-2)
  const w = document.createElement('div');
  w.style.gridColumn = 'span 2';
  w.innerHTML = `
    <div class="spin360">
      <div style="display:flex; justify-content: space-between; align-items: baseline; margin-bottom: 12px;">
        <h5 style="font-size: 11px; letter-spacing: .2em; text-transform: uppercase; margin: 0; font-weight: 600;">360° Önizleme</h5>
        <span style="font-size: 11px; color: var(--ink-3);">8 açıdan</span>
      </div>
      <div class="spin360__viewport">
        ${[1,2,3,4,5,6,7,8].map(n => '<div class="frame f' + n + (n===1?' is-on':'') + '"></div>').join('')}
        <div class="spin360__hint">
          <svg viewBox="0 0 24 24"><path d="M3 12h18m-5-5 5 5-5 5"/><path d="M21 12H3m5-5-5 5 5 5"/></svg>
          Sürükleyin
        </div>
      </div>
      <div class="spin360__scrub"><div></div></div>
    </div>
  `;
  gallery.appendChild(w);

  // Drag-to-rotate logic
  const viewport = w.querySelector('.spin360__viewport');
  const frames = w.querySelectorAll('.frame');
  const scrub = w.querySelector('.spin360__scrub > div');
  let frameIdx = 0, isDown = false, startX = 0, startFrame = 0;
  const setFrame = i => {
    frameIdx = ((i % 8) + 8) % 8;
    frames.forEach((f, j) => f.classList.toggle('is-on', j === frameIdx));
    scrub.style.width = ((frameIdx + 1) / 8 * 100) + '%';
  };
  const onMove = e => {
    if (!isDown) return;
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - startX;
    const r = viewport.getBoundingClientRect();
    const delta = Math.floor(x / (r.width / 8));
    setFrame(startFrame + delta);
  };
  viewport.addEventListener('mousedown', e => { isDown = true; startX = e.clientX; startFrame = frameIdx; });
  viewport.addEventListener('touchstart', e => { isDown = true; startX = e.touches[0].clientX; startFrame = frameIdx; });
  document.addEventListener('mousemove', onMove);
  document.addEventListener('touchmove', onMove);
  document.addEventListener('mouseup', () => isDown = false);
  document.addEventListener('touchend', () => isDown = false);

  // Auto-rotate hint: spin once on load
  let auto = 0;
  const autoTimer = setInterval(() => {
    setFrame(auto++);
    if (auto > 8) clearInterval(autoTimer);
  }, 200);
})();

// === EXT: Video product reviews on PDP ===
// V103-A · Tespit 19: Sahte video review placeholder bloğu (@ayse.g/@selma.k/
// @filiz.y) devre dışı bırakıldı — TKHK Mad. 61 yanıltıcı ticari uygulama riski.
// Gerçek video review entegrasyonu (Loox / Stamped / Judge.me video widget veya
// kendi metafield-backed çözümümüz) hazır olduğunda bu IIFE'yi yeniden etkinleştir.
// Tarihçe: 26 May 2026 V103-A — mobil tarama raporundan kaldırıldı.
(function(){
  return; // V103-A intentional disable; see note above.
})();

// === EXT: A/B Test SDK + Control Panel ===
window.MaisonAB = (function(){
  const experiments = {
    'hero-headline': {
      name: 'Hero başlığı',
      variants: ['A (mevcut)', 'B (cesur)', 'C (sakin)'],
      apply: (v) => {
        const h1 = document.querySelector('.hero h1');
        if (!h1) return;
        if (v === 1) h1.innerHTML = '<span class="line">Bir parça,</span><span class="line"><em>on yıllık</em></span><span class="line">bir hikaye.</span>';
        else if (v === 2) h1.innerHTML = '<span class="line">Sessiz,</span><span class="line"><em>derin</em>,</span><span class="line">sizin.</span>';
      }
    },
    'cta-text': {
      name: 'CTA metni',
      variants: ['Sepete Ekle', 'Şimdi Al', 'Hemen Sahip Ol'],
      apply: (v) => {
        const cta = document.querySelector('.pdp__ctas .btn:first-child');
        if (!cta || v === 0) return;
        cta.firstChild.textContent = experiments['cta-text'].variants[v] + ' · 2.790₺';
      }
    },
    'price-anchor': {
      name: 'Fiyat çapası',
      variants: ['Üstü çizili eski', 'Toplam tasarruf', 'Yok'],
      apply: (v) => {
        const oldPrice = document.querySelectorAll('.pdp__priceOld, .card__price del');
        if (v === 1) {
          oldPrice.forEach(p => {
            p.textContent = 'Tasarruf: 700₺';
            p.style.cssText = 'color: var(--ok); text-decoration: none; font-weight: 500;';
          });
        } else if (v === 2) {
          oldPrice.forEach(p => p.style.display = 'none');
        }
      }
    },
    'scarcity': {
      name: 'Kıtlık vurgusu',
      variants: ['Normal', 'Agresif', 'Yumuşak'],
      apply: (v) => {
        if (v === 1) {
          document.body.classList.add('psych-high');
          document.querySelectorAll('.card__stock').forEach(e => {
            if (!e.textContent.includes('SON')) e.textContent = 'SON ' + e.textContent;
          });
        } else if (v === 2) {
          document.body.classList.add('psych-low');
        }
      }
    },
    'chat-prompt': {
      name: 'Chat butonu metni',
      variants: ['Yardım', 'Destek', 'Sohbet'],
      apply: (v) => {
        const btn = document.querySelector('.chatBtn');
        if (!btn || v === 0) return;
        btn.childNodes.forEach(n => {
          if (n.nodeType === 3 && n.textContent.trim()) n.textContent = experiments['chat-prompt'].variants[v];
        });
      }
    }
  };

  // Read or assign user bucket
  let user = JSON.parse(localStorage.getItem('ml_ab') || '{}');
  let needsSave = false;
  Object.keys(experiments).forEach(k => {
    if (user[k] === undefined) {
      user[k] = Math.floor(Math.random() * experiments[k].variants.length);
      needsSave = true;
    }
  });
  if (needsSave) localStorage.setItem('ml_ab', JSON.stringify(user));

  // FRD: A/B variant application disabled for production — prototype demo only.
  // Variants would randomly override hero/CTA/price text, which interferes with Shopify content.
  // Originally: setTimeout(() => Object.keys(experiments).forEach(k => experiments[k].apply(user[k])), 200);

  return {
    experiments,
    user,
    setVariant(k, v) {
      user[k] = v;
      localStorage.setItem('ml_ab', JSON.stringify(user));
      location.reload();
    },
    resetAll() {
      localStorage.removeItem('ml_ab');
      location.reload();
    }
  };
})();

// AB Control Panel (toggle with Alt+A or ?ab=1)
// FRD: hidden in production — prototype-only floating panel that injected demo controls.
(function(){
  if (!location.search.includes('ab=1')) return; // FRD: only render if explicitly requested
  const show = location.search.includes('ab=1');
  const badge = document.createElement('div');
  badge.className = 'abBadge';
  badge.textContent = 'AB Test · Kontrol';
  document.body.appendChild(badge);

  const panel = document.createElement('div');
  panel.className = 'abPanel';
  const exp = window.MaisonAB.experiments;
  panel.innerHTML = `
    <h5>A/B Test Kontrol Paneli <a id="abClose">×</a></h5>
    ${Object.keys(exp).map(k => `
    <div class="abPanel__row">
      <b>${exp[k].name}</b>
      <div class="vars">
        ${exp[k].variants.map((v, i) => `<button data-k="${k}" data-v="${i}" class="${window.MaisonAB.user[k] === i ? 'is-on' : ''}">${String.fromCharCode(65+i)}</button>`).join('')}
      </div>
    </div>`).join('')}
    <div class="abPanel__row" style="margin-top: 10px;">
      <span style="color: rgba(244,237,226,.5);">Bucket: ${Object.values(window.MaisonAB.user).join('')}</span>
      <button data-reset style="font-size: 10px; padding: 4px 8px; background: transparent; color: rgba(244,237,226,.6); border: 1px solid rgba(244,237,226,.2); cursor: pointer;">Reset</button>
    </div>
  `;
  document.body.appendChild(panel);

  if (show) { panel.classList.add('is-on'); badge.style.display = 'none'; }
  badge.onclick = () => {
    panel.classList.add('is-on');
    badge.style.display = 'none';
  };
  panel.querySelector('#abClose').onclick = () => {
    panel.classList.remove('is-on');
    badge.style.display = 'flex';
  };
  panel.querySelectorAll('button[data-k]').forEach(b => {
    b.onclick = () => window.MaisonAB.setVariant(b.dataset.k, parseInt(b.dataset.v));
  });
  panel.querySelector('[data-reset]').onclick = () => window.MaisonAB.resetAll();

  // Keyboard shortcut: Alt+A
  document.addEventListener('keydown', e => {
    if (e.altKey && (e.key === 'a' || e.key === 'A')) {
      panel.classList.toggle('is-on');
      badge.style.display = panel.classList.contains('is-on') ? 'none' : 'flex';
    }
  });
})();


// ============================================================
// === FRD INTERACTIVE FEATURES — Wishlist + Compare + Quiz
// ============================================================

// --- Wishlist (Favoriler) — localStorage based ---
window.FRDWishlist = (function(){
  var KEY = 'frd_wishlist';
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
  function setArr(arr){ localStorage.setItem(KEY, JSON.stringify(arr)); updateUI(); window.dispatchEvent(new CustomEvent('frd:wishlist:change', { detail: { count: arr.length }})); }
  function has(h){ return get().indexOf(h) !== -1; }
  function add(h){ var a=get(); if (a.indexOf(h)===-1) { a.push(h); setArr(a); flash('Favorilere eklendi'); } }
  function remove(h){ setArr(get().filter(function(x){return x!==h;})); }
  function toggle(h){ if (has(h)) { remove(h); flash('Favorilerden çıkarıldı'); } else { add(h); } return has(h); }
  function count(){ return get().length; }
  function flash(msg){
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--ink,#0c0c0c);color:#fff;padding:12px 22px;font-size:13px;letter-spacing:.08em;z-index:9999;opacity:0;transition:opacity .2s;';
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.style.opacity = '1'; });
    setTimeout(function(){ el.style.opacity = '0'; setTimeout(function(){ el.remove(); }, 250); }, 1600);
  }
  function updateUI(){
    var cnt = count();
    document.querySelectorAll('[data-frd-wishlist-count]').forEach(function(el){
      el.textContent = cnt > 0 ? cnt : '';
      el.style.display = cnt > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-frd-wishlist-btn]').forEach(function(btn){
      var h = btn.dataset.frdWishlistBtn;
      btn.classList.toggle('is-on', has(h));
      // Fill heart svg if active
      var svg = btn.querySelector('svg path');
      if (svg) svg.setAttribute('fill', has(h) ? 'currentColor' : 'none');
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-frd-wishlist-btn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h = btn.dataset.frdWishlistBtn;
    if (h) toggle(h);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUI);
  } else {
    updateUI();
  }
  return { get: get, add: add, remove: remove, toggle: toggle, has: has, count: count, updateUI: updateUI };
})();

// --- Compare (Karşılaştır) — localStorage based, max 4 ---
window.FRDCompare = (function(){
  var KEY = 'frd_compare', MAX = 4;
  function get(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
  function setArr(arr){ localStorage.setItem(KEY, JSON.stringify(arr)); updateUI(); window.dispatchEvent(new CustomEvent('frd:compare:change', { detail: { count: arr.length }})); }
  function has(h){ return get().indexOf(h) !== -1; }
  function add(h){ var a=get(); if (a.indexOf(h)!==-1) return false; if (a.length>=MAX) { flash('En fazla '+MAX+' ürün karşılaştırabilirsiniz'); return false; } a.push(h); setArr(a); flash('Karşılaştırmaya eklendi'); return true; }
  function remove(h){ setArr(get().filter(function(x){return x!==h;})); }
  function clear(){ setArr([]); }
  function toggle(h){ if (has(h)) { remove(h); flash('Karşılaştırmadan çıkarıldı'); } else { add(h); } }
  function count(){ return get().length; }
  function flash(msg){
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--accent-dk,#4c1119);color:#fff;padding:12px 22px;font-size:13px;letter-spacing:.08em;z-index:9999;opacity:0;transition:opacity .2s;';
    document.body.appendChild(el);
    requestAnimationFrame(function(){ el.style.opacity = '1'; });
    setTimeout(function(){ el.style.opacity = '0'; setTimeout(function(){ el.remove(); }, 250); }, 1600);
  }
  function updateUI(){
    var cnt = count();
    document.querySelectorAll('[data-frd-compare-count]').forEach(function(el){
      el.textContent = cnt > 0 ? cnt : '';
      el.style.display = cnt > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-frd-compare-btn]').forEach(function(btn){
      btn.classList.toggle('is-on', has(btn.dataset.frdCompareBtn));
    });
    // Show floating compare bar if at least 1 item
    var bar = document.querySelector('.frd-compare-bar');
    if (bar) {
      if (cnt > 0) bar.classList.add('is-on'); else bar.classList.remove('is-on');
      var info = bar.querySelector('[data-compare-info]');
      if (info) info.textContent = cnt + ' ürün karşılaştırmada';
    }
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-frd-compare-btn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    toggle(btn.dataset.frdCompareBtn);
  });
  // Inject floating compare bar
  function injectBar(){
    if (document.querySelector('.frd-compare-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'frd-compare-bar';
    bar.innerHTML = '<span data-compare-info></span><div><a href="/pages/karsilastir" class="btn">Karşılaştır →</a> <button type="button" onclick="FRDCompare.clear()" style="background:none;border:0;color:inherit;cursor:pointer;font-size:11px;letter-spacing:.1em;text-transform:uppercase;margin-left:14px;text-decoration:underline;">Temizle</button></div>';
    document.body.appendChild(bar);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ injectBar(); updateUI(); });
  } else { injectBar(); updateUI(); }
  return { get: get, add: add, remove: remove, has: has, toggle: toggle, count: count, clear: clear };
})();


// === EXT: Desktop mega menu (V74) ===
(function(){
  function init(){
    if (window.innerWidth < 721) return;
    const navLeft = document.querySelector('.nav__left');
    const navParent = document.querySelector('.nav');
    if (!navLeft || !navParent) return;
    if (navParent.querySelector('.megaMenu')) return;

    const data = (window.FRD_NAV_DATA && window.FRD_NAV_DATA.menus) || {};
    if (Object.keys(data).length === 0) return;

    // Strip the old single-line dropdown markup if present (Liquid section may still render .nav__drop)
    navLeft.querySelectorAll('.nav__drop').forEach(function(drop){
      const a = drop.querySelector('a.nav__link');
      if (!a) { drop.remove(); return; }
      // Clean trailing chevron span
      a.querySelectorAll('span').forEach(function(s){ if (/^[›▾▼>]+$/.test(s.textContent.trim())) s.remove(); });
      drop.parentNode.insertBefore(a, drop);
      drop.remove();
    });
    // Also remove any old nav__megamenu nodes
    navLeft.querySelectorAll('.nav__megamenu').forEach(function(n){ n.remove(); });

    const container = document.createElement('div');
    container.className = 'megaMenu';
    navParent.appendChild(container);

    function render(menuKey){
      const m = data[menuKey];
      if (!m) return;
      const hasFeature = m.feature && (m.feature.title || m.feature.cta);
      // V296: görsel seçilmemiş feature bloklarında .ph deseni (bordo/siyah
      // degrade dikdörtgen) basılıyordu — panelin en büyük öğesi bir yer
      // tutucu oluyordu. Görsel yoksa blok hiç basılmaz, kart metin kalır.
      const featureHTML = hasFeature ? `
        <div class="megaMenu__feature${m.feature.image ? '' : ' no-image'}">
          <div>
            ${m.feature.image ? `<div class="ph ph--photo" style="background-image:url('${m.feature.image}')"></div>` : ''}
            <h4>${m.feature.title || ''}</h4>
            <p>${m.feature.desc || ''}</p>
          </div>
          ${m.feature.cta ? `<a class="btn--link" href="${m.feature.href || '#'}">${m.feature.cta}</a>` : ''}
        </div>` : '';

      // V296: ızgara 4 sütuna sabitti; menüde 1 sütun varsa 3 hayalet sütun
      // boş kalıyor, feature kartı da 5. sütuna itilip aradaki devasa boşluğu
      // görünür kılıyordu. Sütun sayısı artık menünün kendisinden geliyor.
      const colCount = Math.max(1, (m.cols || []).length);

      container.innerHTML = `
        <div class="megaMenu__inner${hasFeature ? '' : ' no-feature'}" style="--mm-cols:${colCount}">
          ${(m.cols || []).map(c => `
          <div class="megaMenu__col">
            ${c.title ? `<h5>${c.title}</h5>` : ''}
            <ul>
              ${(c.links || []).map(([t, href, k]) => `<li><a href="${href}">${t}${k ? ' <span class="k">'+k+'</span>' : ''}</a></li>`).join('')}
            </ul>
          </div>`).join('')}
          ${featureHTML}
        </div>
      `;
    }

    const navLinks = navLeft.querySelectorAll('.nav__link');
    let hoverTimer;
    let currentKey = null;
    const CLOSE_DELAY = 260;

    function open(link, key){
      clearTimeout(hoverTimer);
      if (currentKey !== key){
        currentKey = key;
        render(key);
      }
      container.classList.add('is-open');
      navLinks.forEach(l => l.setAttribute('aria-expanded', l === link ? 'true' : 'false'));
    }

    // V296: bir menünün açılır paneli hak edip etmediği.
    // "Sezon Sonu / Outlet / Temel Parçalar" panellerinin içinde tek bir bağlantı
    // vardı ve o bağlantı başlığın kendisiydi ("Sezon Sonu → /collections/sezon-sonu").
    // Yani panel, üstündeki linkin aynısını tekrarlamak için 365px'lik boş bir
    // şerit açıyordu. Kendini tekrar eden tek linkli menüde panel açılmaz;
    // başlık düz link gibi davranır.
    function panelHakEdiyorMu(m, link){
      const links = (m.cols || []).reduce((acc, c) => acc.concat(c.links || []), []);
      if (links.length > 1) return true;
      if (links.length === 0) return false;
      const norm = (s) => String(s || '').replace(/\/$/, '').toLowerCase();
      const ayniEtiket = norm(links[0][0]) === norm(link.textContent.trim());
      const ayniHedef = norm(links[0][1]) === norm(link.getAttribute('href'));
      return !(ayniEtiket || ayniHedef);
    }

    navLinks.forEach(link => {
      const text = link.textContent.trim();
      const matchKey = Object.keys(data).find(k => k.toLowerCase() === text.toLowerCase());
      if (!matchKey) return;
      if (!panelHakEdiyorMu(data[matchKey], link)) return;
      link.classList.add('has-menu');
      link.setAttribute('aria-expanded', 'false');
      link.dataset.megaKey = matchKey;
      link.addEventListener('mouseenter', () => open(link, matchKey));
      // Focus opens too (keyboard a11y); blur is handled by scheduleClose on nav mouseleave
      link.addEventListener('focus', () => open(link, matchKey));
    });

    container.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
    // Keep menu open while pointer is anywhere over the nav bar (including the gap
    // between the link row and the dropdown). Without this the original mouseleave
    // on .nav__left fires the instant the cursor enters the empty space below the
    // links — even though .megaMenu is directly underneath — and the 180 ms close
    // timer trips before the cursor reaches the dropdown, producing the flicker.
    navParent.addEventListener('mouseenter', () => clearTimeout(hoverTimer));

    function scheduleClose(){
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(() => {
        container.classList.remove('is-open');
        navLinks.forEach(l => l.setAttribute('aria-expanded','false'));
        currentKey = null;
      }, CLOSE_DELAY);
    }
    // Listen on the whole nav (not just .nav__left) so traversing through nav padding
    // or .nav__right does not trigger a premature close.
    navParent.addEventListener('mouseleave', scheduleClose);
    container.addEventListener('mouseleave', scheduleClose);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape'){
        container.classList.remove('is-open');
        navLinks.forEach(l => l.setAttribute('aria-expanded','false'));
        currentKey = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================================
   V202 — Ürün kartı etkileşimleri (NetWork davranışları)

   İki iş yapar:
   1) Renk kutucuğuna gelince kart görselini o rengin fotoğrafına çevirir.
      CSS ile yapılamaz: kutucuk DOM'da görselden SONRA geliyor, CSS geriye
      doğru seçemiyor. NetWork da bunu JS ile yapıyor (Vue mouseenter).
   2) Hover'da açılan beden katmanında bir bedene tıklanınca ürünü doğrudan
      sepete atar (ürün sayfasına gitmeden) ve sepet çekmecesini açtırır.
      `cart:update` olayını yayar — farren-auto-open-cart.liquid onu dinliyor.

   Fotoğraf gezinme şeridi bilerek burada değil: o tamamen CSS
   (.card__hotspot:hover + .card__preview), JS'e ihtiyacı yok.
   ========================================================================= */
(function () {
  'use strict';

  /* --- 1) Renk kutucuğu → görsel değişimi ------------------------------- */
  function swapImage(swatch, on) {
    var card = swatch.closest('.card');
    if (!card) return;
    var layer = card.querySelector('.card__colorSwap');
    if (!layer) return;
    var src = swatch.getAttribute('data-frd-swatch-img');
    if (on && src) {
      if (layer.getAttribute('src') !== src) layer.setAttribute('src', src);
      layer.classList.add('is-on');
    } else {
      layer.classList.remove('is-on');
    }
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-frd-swatch-img]');
    if (sw) swapImage(sw, true);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('[data-frd-swatch-img]');
    if (sw) swapImage(sw, false);
  });

  /* --- 2) Beden katmanından hızlı sepete ekleme -------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-frd-size]');
    if (!btn || btn.disabled || btn.classList.contains('is-busy')) return;

    // Kartın kendi onclick'i ürün sayfasına gidiyor — buradan çıkışı kes.
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-frd-size');
    if (!id) return;
    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () {
        // Tema iki adı da kullanıyor; ikisini de yayalım.
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        // Sepet rozetini tazele (drawer kendi yenilemezse sayı bayat kalmasın).
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count ? '' : 'none';
            });
          })
          .catch(function () {});
      })
      .catch(function (err) {
        console.warn('[farren] hızlı sepete ekleme başarısız:', err);
        // Sessiz kalmayalım: kullanıcıyı ürün sayfasına götür.
        var card = btn.closest('.card');
        var a = card && card.querySelector('a[href*="/products/"]');
        if (a) location.href = a.getAttribute('href');
      })
      .then(function () {
        btn.classList.remove('is-busy');
      });
  }, true);
})();

/* =========================================================================
   V204 — PDP tam ekran zoom (NetWork .zoom-images birebir)

   Davranış: galeri fotoğrafına tıklanınca tam ekran beyaz katman açılır;
   solda dikey küçük resim rayı (#fafafa zemin, 70×105 karo, sönük 0.4,
   aktif 1), ortada büyük fotoğraf, sağ üstte kapat. Fotoğrafa tıklamak
   2× yakınlaştırır (NetWork'te swiper-zoom-container). Klavye: ← → Esc.
   Mobilde ray yatay ve altta.

   Sadece görünen (renk filtresi geçmiş) fotoğraflar rayda listelenir —
   PDP renk seçici galeri slotlarını display:none yapıyor, gizli olanı
   zoom'a taşımak kafa karıştırır.
   ========================================================================= */
(function () {
  'use strict';
  if (typeof window.frdPath !== 'function' || window.frdPath() !== 'urun.html') return;

  var root = null, imgEl = null, railEl = null, shots = [], idx = 0;




  /* V260-ilk-ekran — parmakla sağa/sola kaydırma. Önce yalnız küçük resim rayı vardı;
     mobilde kimse rayı kullanmıyor. Dikey kaydırmayı engellemez: yatay hareket
     dikeyin 1,5 katından fazlaysa fotoğraf değiştirilir. */
  var swipeBound = false;
  function bindSwipe() {
    if (swipeBound || !root) return;
    swipeBound = true;
    var x0 = 0, y0 = 0, t0 = 0;
    var stage = root.querySelector('.frd-zoom__stage');
    if (!stage) return;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!t0 || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      t0 = 0;
      if (imgEl && imgEl.classList.contains('is-zoomed')) return;  // yakınlaştırılmışken kaydırma serbest
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var n = idx + (dx < 0 ? 1 : -1);
      if (n < 0) n = shots.length - 1;
      if (n >= shots.length) n = 0;
      show(n);
    }, { passive: true });
  }

  function visibleShots() {
    var out = [];
    document.querySelectorAll('.pdp__gallery > div').forEach(function (slot) {
      if (slot.offsetParent === null) return;           // renk filtresiyle gizli
      var im = slot.querySelector('img');
      /* V260-ilk-ekran: galeri 1024px sunar; büyütmede GERÇEK boyut istiyoruz. */
      if (im && im.getAttribute('src')) {
        var full = im.src.replace(/([?&])width=\d+/, '$1width=1800');
        out.push({ src: full, alt: im.alt || '', thumb: im.src });
      }
    });
    return out;
  }

  function build() {
    root = document.createElement('div');
    root.className = 'frd-zoom';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<button type="button" class="frd-zoom__close" aria-label="Kapat">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.6"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<div class="frd-zoom__rail" role="tablist"></div>' +
      '<div class="frd-zoom__stage"><img class="frd-zoom__img" alt=""></div>';
    document.body.appendChild(root);
    imgEl = root.querySelector('.frd-zoom__img');
    railEl = root.querySelector('.frd-zoom__rail');

    root.querySelector('.frd-zoom__close').addEventListener('click', close);
    imgEl.addEventListener('click', function () { imgEl.classList.toggle('is-zoomed'); });
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target.classList.contains('frd-zoom__stage')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (root.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }

  function show(i) {
    if (!shots.length) return;
    idx = (i + shots.length) % shots.length;
    imgEl.src = shots[idx].src;
    imgEl.alt = shots[idx].alt;
    imgEl.classList.remove('is-zoomed');
    railEl.querySelectorAll('.frd-zoom__thumb').forEach(function (t, n) {
      t.classList.toggle('is-on', n === idx);
      if (n === idx && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  function open(startIndex) {
    shots = visibleShots();
    if (!shots.length) return;
    if (!root) build();
    railEl.innerHTML = '';
    shots.forEach(function (s, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'frd-zoom__thumb';
      b.setAttribute('aria-label', (n + 1) + '. fotoğraf');
      b.innerHTML = '<img src="' + s.src + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { show(n); });
      railEl.appendChild(b);
    });
    root.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    show(startIndex || 0);
    bindSwipe();
  }

  function close() {
    if (!root) return;
    root.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var slot = e.target.closest && e.target.closest('.pdp__gallery > div');
    if (!slot || !slot.querySelector('img')) return;
    e.preventDefault();
    var all = [].slice.call(document.querySelectorAll('.pdp__gallery > div')).filter(function (d) {
      return d.offsetParent !== null && d.querySelector('img');
    });
    open(all.indexOf(slot));
  });
})();

/* =========================================================================
   V204 — Mobil sabit sepet çubuğu: TEMADA ZATEN VAR.
   NetWork'ün .sticky-area karşılığını yazmıştım; canlıda mevcut `.sticky-atc`
   çubuğuyla (ürün adı + renk/beden + eski/yeni fiyat + Sepete Ekle) üst üste
   binince iki çubuk göründü. Mükerrer olanı kaldırdım — mevcut çubuk zaten
   NetWork'ünkinden daha bilgi dolu ve tab-bar üstüne konumlanmış durumda.
   ========================================================================= */

/* =========================================================================
   V205 — Izgara görünüm seçici (NetWork "Görünüm:" 3'lü / 4'lü)

   Seçim localStorage'da tutulur ki koleksiyonlar arasında gezerken
   kullanıcının tercihi korunsun (NetWork de tercihi hatırlıyor).
   Ürün ızgarası `.grid-3`; 4'lü görünümde `.is-quad` eklenir.
   ========================================================================= */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-frd-viewswitch]');
  if (!wrap) return;
  var grid = document.querySelector('.listing .grid-3') || document.querySelector('.grid-3');
  if (!grid) return;

  var KEY = 'frd-grid-view';

  function apply(v, persist) {
    grid.classList.toggle('is-quad', v === '4');
    wrap.querySelectorAll('[data-frd-view]').forEach(function (b) {
      var on = b.getAttribute('data-frd-view') === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (persist) {
      try { localStorage.setItem(KEY, v); } catch (e) {}
    }
  }

  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  if (saved === '3' || saved === '4') apply(saved, false);

  wrap.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-frd-view]');
    if (!btn) return;
    apply(btn.getAttribute('data-frd-view'), true);
  });
})();

/* =========================================================================
   V207 — Kategori sayfası SEO metni "Devamını Göster / Gizle"
   NetWork'te metin 4 satırda (mobilde 5) kırpılır; düğme metni açık/kapalı
   durumuna göre değişir. Metin zaten sığıyorsa düğme hiç gösterilmez.
   ========================================================================= */
(function () {
  'use strict';
  var box = document.querySelector('[data-frd-seotext]');
  if (!box) return;
  var body = box.querySelector('.seoText__body');
  var btn = box.querySelector('[data-frd-seotoggle]');
  if (!body || !btn) return;

  // Kırpılmıyorsa düğmeye gerek yok
  if (body.scrollHeight <= body.clientHeight + 4) {
    btn.style.display = 'none';
    return;
  }

  btn.addEventListener('click', function () {
    var open = box.classList.toggle('is-open');
    btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
  });
})();
